<template>
  <div class="monitoring">
    <!-- Monitoring Section-->
    <div class="bg-black p-2 rounded">
      <div class="row" align="center">
            <div class="col-md-5">
                <div class="input-group flex-nowrap">
                    <button v-if="false" class="btn btn-alchemy fs-3 rounded" style="pointer-events: none;" :disabled="cloud_mode != 'table'">
                        <div class="input-group flex-nowrap">
                            <i class="fa-solid fa-xl fa-compass" :class="{'fa-spin': autoRefresh}"></i>
                        </div>
                    </button>
                    <select type="text" class="btn bg-black text-white fw-light fs-2 text-start w-100" style="letter-spacing: 5px; cursor: default;" v-model="dvmode" :class="{'fa-fade': gettingMarkers || getting_cloud_markers || autoRefresh}" :disabled="cloud_mode != 'table'">
                        <option value="standard_devices">Standard Monitoring</option>
                        <option value="cloud_devices">Cloud Monitoring</option>
                    </select>
                </div>
            </div>
            <div class="col-md-3">
                <input v-if="autoRefresh" type="text" class="btn bg-black text-white text-start fw-light fs-6 w-100 mt-3 fa-fade" :class="{'fa-fade': gettingMarkers}" style="letter-spacing: 2px; cursor: default; opacity: 1;" :value="statusText" readonly>
            </div>
            <div class="col-md-4">
                <div class="input-group flex-nowrap mt-1" v-show="autoRefresh">
                    <input type="text" class="btn bg-black text-white fw-light fs-3 text-end w-100 fa-fade" style="letter-spacing: 5px; cursor: default;" :value="now" readonly>
                    <button class="btn bg-black fs-4 text-end" style="width:12%; cursor: default;">
                        <i class="fa-solid fa-xl fa-compass text-alchemy" :class="{'fa-spin': autoRefresh}"></i>
                    </button>
                </div>
            </div>
      </div>
    </div>
    <div class="bg-black p-2 rounded mt-1" style="height: 600px;">
        <!-- STANDARD DEVICES -->
        <div v-if="dvmode=='standard_devices'" class="row">
            <div class="col-md-1">
                <div class="bg-alchemy-two bg-gradient p-2 rounded" style="height: 585px;">
                    <button class="btn fs-3 text-white">
                        <i class="fa-solid fa-xl fa-desktop"></i>
                    </button>
                    <button class="btn btn-alchemy fs-3 w-100 mt-2" @click="clearMonitoring">
                        <i class="fa-solid fa-xl fa-arrows-rotate" :class="{'fa-spin': gettingMarkers || cleaningMonitoring}"></i>
                    </button>
                    <button class="btn btn-alchemy fs-3 w-100 mt-2" @click="toggleView()">
                        <i class="fa-solid fa-xl" :class="{'fa-list': sectionView=='map', 'fa-map': sectionView=='list'}"></i>
                    </button>
                    <button class="btn btn-alchemy fs-3 w-100 mt-2" @click="compact = !compact">
                        <i class="fa-solid fa-xl" :class="{'fa-minimize': !compact, 'fa-maximize': compact}"></i>
                    </button>
                    <button class="btn btn-alchemy fs-3 w-100 mt-2" data-bs-toggle="modal" data-bs-target="#tester" @click="cleanLAB();" title="Open laboratory.">
                        <i class="fa-solid fa-xl fa-flask"></i>
                    </button>
                </div>
            </div>
            <!-- Table of Markers (NOT COMPACT) -->
            <div class="col-md-11" v-show="sectionView=='list'  && !compact">
                <div class="input-group flex-nowrap">
                    <button class="btn fw-light btn-alchemy fs-5 text-start rounded me-1">
                        {{filteredMarkers.length}}
                    </button>
                    <select class="btn fw-light bg-alchemy bg-gradient fs-6 text-start rounded" style="width: 20%;" v-model="cats" @change="refreshMarkersFilter">
                        <option :value="null">All OS's</option>
                        <option :value="false">Not superficials.</option>
                        <option :value="true">Superficials</option>
                    </select>
                    <input class="btn fw-light bg-alchemy fs-6 w-25" type="text" style="cursor: default;" placeholder="Search by..." v-model="searchWord">
                    <select class="btn fw-light bg-alchemy bg-gradient fs-6 text-start rounded w-25" v-model="search_std_type">
                        <option value="name">By Name</option>
                        <option value="alias">By Alias</option>
                        <option value="ip">By IP Address</option>
                        <option value="os">By OS</option>
                        <option value="role">By Role</option>
                    </select>
                    <div style="width: 30%;"></div>
                    <button class="btn fs-6 rounded me-2" :class="{'bg-alchemy-success': only_active, 'bg-alchemy bg-gradient': !only_active}" @click="only_active = !only_active">
                        <i class="fa-solid fa-xl fa-power-off"></i>
                    </button>
                    <select class="btn fw-light bg-alchemy bg-gradient fs-6 text-start rounded" style="width: 20%;" v-model="devices_filter" @change="refreshMarkersFilter">
                        <option :value="null">Sorting</option>
                        <option value="cpu_desc">CPU (Desc)</option>
                        <option value="memory_desc">Memory (Desc)</option>
                        <option value="ping_lat_desc">Ping Latency (Desc)</option>
                        <option value="alerts">Alerts (Desc)</option>
                    </select>
                </div>
                <div class="mt-1" :class="{'disabled-div': gettingMarkers}">
                    <div class="tableFixHead border border-dark rounded"  style="height: 537px; border-top: solid 1px grey;">
                        <table>
                            <thead>
                                <tr>
                                    <th v-if="false" class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Device Name">
                                        <i class="fa-solid fa-lg fa-map-location"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Device Role">
                                        <i class="fa-solid fa-lg fa-cube"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Device OS">
                                        OS
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Device Name">
                                        <select class="btn fs-5 text-white" v-model="search_std_type">
                                            <option value="name">Hostname</option>
                                            <option value="alias">Alias</option>
                                            <option value="ip">IP Address</option>
                                            <option value="os">By OS</option>
                                            <option value="role">By Role</option>
                                        </select>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 p-1" title="Connectivity">
                                        <i class="fa-solid fa-lg fa-tower-broadcast"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 p-1" title="Ping">
                                        <i class="fa-solid fa-lg fa-rss"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 p-1" title="CPU Usage">
                                        <i class="fa-solid fa-lg fa-microchip"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 p-1" title="Memory Usage">
                                        <i class="fa-solid fa-lg fa-memory"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Total Targets">
                                        <i class="fa-solid fa-lg fa-bullseye" ></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Total Targets">
                                        <i class="fa-solid fa-lg fa-triangle-exclamation" ></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Targets">
                                        <i class="fa-solid fa-lg fa-eye"></i>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(marker, mrkIndex) in filteredMarkers" v-bind:key="mrkIndex+1"> <!-- Content Row -->
                                    <td v-if="false" class="fw-light text-white fs-6 text-center bg-black" style="width: 30px; border-bottom: solid 1px rgb(50,50,50)">
                                        <button class="btn btn-alchemy-dark bg-gradient fw-light fs-6 w-100"  title="Locate device on the map."
                                        @click="setMapCenter(marker.coords[0], marker.coords[1], 7)">
                                            <i class="fa-solid fa-lg fa-map-location"></i>
                                        </button>
                                    </td>
                                    <!-- Role -->
                                    <td class="text-center bg-black" style="width: 10%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button class="btn fw-light  fs-6">
                                            <img id="roleimg" :src="getImage(marker.role)" :title="String(marker.role).toUpperCase()" :alt="marker.role" width="65" class="img-fluid rounded border-0">
                                        </button>
                                    </td>
                                    <!-- OS -->
                                    <td class="text-center bg-black" style="width: 10%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button class="btn fw-light btn-alchemy-dark bg-gradient fs-6">
                                            <img :src="getImage(oss[marker.os])" :title="String(oss[marker.os]).toUpperCase()" width="65" class="img-fluid rounded border-0">
                                        </button>
                                    </td>
                                    <td class="fw-light text-white fs-6 text-center bg-black" style="width: 300px; border-bottom: solid 1px rgb(50,50,50)">
                                        <input type="text" class="btn text-white fw-light fs-6 text-center border-0 w-100" style="cursor: pointer;" :value="String(marker[search_std_type]).toUpperCase()" :title="`Device: ${marker.name}\nLast Update: ${marker.last_update}\nDevice Message: ${marker.device_message}`" readonly>
                                    </td>
                                    <!-- Connectivity -->
                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);" >
                                        <button class="btn fw-light fs-6 w-100" :class="{ 'btn-alchemy-success': marker.polling.value && marker.connectivity.value, 'btn-alchemy-danger': marker.polling.value && !marker.connectivity.value, 'btn-alchemy-off': !marker.polling.value || marker.connectivity.value == null }" readonly>
                                            <i v-if="marker.polling.value" class="fa-solid fa-lg fa-tower-broadcast" :title="`Connectivity: ${marker.connectivity.value}`"></i>
                                            <i v-if="!marker.polling.value" class="fa-solid fa-lg fa-minus" title="Inactive polling."></i>
                                        </button>
                                    </td>
                                    <!-- Ping -->
                                    <td class="text-center bg-black" style="width: 20%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button class="btn fw-light fs-6 w-100" :class="{ 'btn-alchemy-success': marker.polling.value && marker.ping.success > marker.ping.tolerance , 'btn-alchemy-danger': marker.polling.value && marker.ping.success <= marker.ping.tolerance, 'btn-alchemy-off': !marker.polling.value }">
                                            <span v-if="marker.polling.value" :title="`Ping | Success: ${marker.ping.success}% | Loss: ${marker.ping.loss}% | RTT: ${marker.ping.rtt} | Latency: ${marker.ping.latency} | Jitter: ${marker.ping.jitter}`">{{marker.ping.success}}% | {{marker.ping.latency}} ms | {{marker.ping.jitter}} ms</span>
                                            <span v-if="!marker.polling.value" title="Inactive polling.">-</span>
                                        </button>
                                    </td>
                                    <!-- CPU -->
                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button v-if="marker.polling.value && marker.cpu.exec" class="btn fw-light fs-6 w-100" :title="`CPU | Usage: ${marker.cpu.value}% | Tolerance: ${marker.cpu.tolerance}%`"
                                        :class="{'btn-alchemy-success': marker.cpu.value < marker.cpu.tolerance, 'btn-alchemy-danger': marker.cpu.value >= marker.cpu.tolerance }">
                                            {{marker.cpu.value}}%
                                        </button>
                                        <button v-if="!marker.polling.value || !marker.cpu.exec" class="btn btn-alchemy-off fw-light fs-6 w-100">
                                            -
                                        </button>
                                    </td>
                                    <!-- Memory -->
                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button v-if="marker.polling.value && marker.memory.exec" class="btn fw-light fs-6 w-100" :title="`Memory | Usage: ${marker.memory.value}% | Tolerance: ${marker.memory.tolerance}%`"
                                        :class="{'btn-alchemy-success': marker.memory.value < marker.memory.tolerance, 'btn-alchemy-danger': marker.memory.value >= marker.memory.tolerance }">
                                            {{marker.memory.value}}%
                                        </button>
                                        <button v-if="!marker.polling.value || !marker.memory.exec" class="btn btn-alchemy-off fw-light fs-6 w-100">
                                            -
                                        </button>
                                    </td>
                                    <!-- All Targets -->
                                    <td class="text-center bg-black" style="width: 12%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button v-if="marker.polling.value" class="btn fw-light fs-6 w-100" data-bs-toggle="modal" data-bs-target="#deviceDetail"  @click="viewMarker(marker, 'targets');"
                                            :class="{ 'btn-alchemy-success': marker.targets.exec_targets, 'btn-alchemy-off': !marker.targets.exec_targets }">
                                            <span :title="`Total targets: ${marker.targets.total}\nUp targets: ${marker.targets.up}\nNot up targets: ${marker.targets.notup}`" v-if="marker.targets.exec_targets">{{ marker.targets.total }} | {{marker.targets.up}} | {{marker.targets.notup}}</span>
                                            <span title="Inactive targets monitoring." v-if="!marker.targets.exec_targets">-</span>
                                        </button>
                                        <button v-if="!marker.polling.value" class="btn btn-alchemy-off fw-light fs-6 w-100" title="Inactive target polling.">
                                            -
                                        </button>
                                    </td>
                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);" title="Alerts">
                                        <button class="btn fw-light fs-6 w-100" data-bs-toggle="modal" data-bs-target="#deviceDetail"  @click="viewMarker(marker, 'alerts');" :class="{'btn-alchemy-dark bg-gradient': marker.alerts.length == 0, 'btn-alchemy-danger': marker.alerts.length > 0}">
                                            {{marker.alerts.length}}
                                        </button>
                                    </td>
                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button class="btn btn-alchemy-dark bg-gradient fw-light fs-6 w-100" data-bs-toggle="modal" data-bs-target="#deviceDetail" @click="viewMarker(marker)" :disabled="autoRefresh || marker.is_new">
                                            <i class="fa-solid fa-lg fa-eye"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Table of Markers (COMPACT) -->
            <div class="col-md-11" v-show="sectionView=='list' && compact">
                <div class="input-group flex-nowrap">
                    <button class="btn fw-light btn-alchemy fs-5 text-center rounded me-1" style="width: 10%;">
                        {{filteredMarkers.length}}
                    </button>
                    <select class="btn fw-light bg-alchemy bg-gradient fs-6 text-start rounded" style="width: 20%;" v-model="cats" @change="refreshMarkersFilter">
                        <option :value="null">All OS's</option>
                        <option :value="false">Not superficials.</option>
                        <option :value="true">Superficials</option>
                    </select>
                    <input class="btn fw-light bg-alchemy fs-6 w-25" type="text" style="cursor: default;" placeholder="Search by..." v-model="searchWord">
                    <select class="btn fw-light bg-alchemy bg-gradient fs-6 text-start rounded w-25" v-model="search_std_type">
                        <option value="name">By Name</option>
                        <option value="alias">By Alias</option>
                        <option value="ip">By IP Address</option>
                        <option value="service_key">By Service Key</option>
                        <option value="os">By OS</option>
                        <option value="role">By Role</option>
                    </select>
                    <div style="width: 30%;"></div>
                    <button class="btn fs-6 rounded me-2" :class="{'bg-alchemy-success': only_active, 'bg-alchemy bg-gradient': !only_active}" @click="only_active = !only_active">
                        <i class="fa-solid fa-xl fa-power-off"></i>
                    </button>
                    <select class="btn fw-light bg-alchemy bg-gradient fs-6 text-start rounded" style="width: 20%;" v-model="devices_filter" @change="refreshMarkersFilter">
                        <option :value="null">Sorting</option>
                        <option value="cpu_desc">CPU (Desc)</option>
                        <option value="memory_desc">Memory (Desc)</option>
                        <option value="ping_lat_desc">Ping Latency (Desc)</option>
                        <option value="alerts">Alerts (Desc)</option>
                    </select>
                </div>
                <div class="mt-1" :class="{'disabled-div': gettingMarkers}">
                    <div class="tableFixHead border border-dark rounded"  style="height: 537px; border-top: solid 1px grey;">
                        <table>
                            <thead>
                                <tr>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 p-1" title="Device Name">
                                        <i class="fa-solid fa-lg fa-desktop"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Device Name">
                                        <select class="btn fs-5 text-white text-start w-100" v-model="search_std_type">
                                            <option v-if="search_std_type == 'name'" value="name">Alias</option>
                                            <option v-if="search_std_type != 'name'" value="alias">Alias</option>
                                            <option value="ip">IP Address</option>
                                            <option value="service_key">Service Key</option>
                                            <option value="os">OS</option>
                                            <option value="role">Role</option>
                                        </select>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 p-1" title="Role & OS">
                                        <i class="fa-solid fa-lg fa-cube"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 p-1" title="Connectivity">
                                        <i class="fa-solid fa-lg fa-tower-broadcast"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 p-1" title="Ping">
                                        <i class="fa-solid fa-lg fa-rss"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 p-1" title="CPU Usage">
                                        <i class="fa-solid fa-lg fa-microchip"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 p-1" title="Memory Usage">
                                        <i class="fa-solid fa-lg fa-memory"></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Total Targets">
                                        <i class="fa-solid fa-lg fa-bullseye" ></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Total Targets">
                                        <i class="fa-solid fa-lg fa-triangle-exclamation" ></i>
                                    </th>
                                    <th class="fw-light bg-alchemy bg-gradient text-white fs-5 rounded p-1" title="Targets">
                                        <i class="fa-solid fa-lg fa-eye"></i>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(marker, mrkIndex) in filteredMarkers" v-bind:key="mrkIndex+1"> <!-- Content Row -->
                                    <td class="text-white text-center bg-black" style="width: 200px; border-bottom: solid 1px rgb(50,50,50)">
                                        <input type="text" class="btn text-white text-start fw-bold border-0 w-100" style="cursor: text; font-size: 14px; pointer-events: none;" :value="`${marker.name.toUpperCase()}`" :title="`Device: ${marker.name}\nLast Update: ${marker.last_update}\nDevice Message: ${marker.device_message}`" readonly>
                                    </td>
                                     <!-- SELECTION -->
                                    <td class="text-white text-center bg-black" style="width: 200px; border-bottom: solid 1px rgb(50,50,50)">
                                        <input v-if="search_std_type == 'name'" type="text" class="btn text-white text-start fw-bold border-0 w-100" style="cursor: text; font-size: 14px; pointer-events: none;" :value="marker.alias.toUpperCase()" readonly>
                                        <input v-if="search_std_type != 'name'" type="text" class="btn text-white text-start fw-bold border-0 w-100" style="cursor: text; font-size: 14px; pointer-events: none;" :value="marker[search_std_type].toUpperCase()" readonly>
                                    </td>
                                    <!-- ROLE/OS -->
                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);" >
                                        <button class="btn fw-light w-100" :class="{'btn-info':marker.os == 'superficial', 'btn-alchemy': marker.os != 'superficial' }" :title="`${String(marker.role).toUpperCase()} with OS: ${String(marker.os).toUpperCase()}`" readonly>
                                            <i class="fa-solid" :class="{'fa-water': marker.os == 'superficial', 'fa-desktop': marker.os != 'superficials'}"></i>
                                        </button>
                                    </td>
                                    <!-- Connectivity -->
                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);" >
                                        <button class="btn fw-light w-100" :class="{ 'btn-alchemy-success': marker.polling.value && marker.connectivity.value, 'btn-alchemy-danger': marker.polling.value && !marker.connectivity.value, 'btn-alchemy-off': !marker.polling.value || marker.connectivity.value == null }" readonly>
                                            <i v-if="marker.polling.value" class="fa-solid fa-tower-broadcast" :title="`Connectivity: ${marker.connectivity.value}`"></i>
                                            <i v-if="!marker.polling.value" class="fa-solid fa-minus" title="Inactive polling."></i>
                                        </button>
                                    </td>
                                    <!-- Ping -->
                                    <td class="text-center bg-black" style="width: 20%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button class="btn fw-light w-100" style="font-size: 13px;" :class="{ 'btn-alchemy-success': marker.polling.value && marker.ping.success > marker.ping.tolerance , 'btn-alchemy-danger': marker.polling.value && marker.ping.success <= marker.ping.tolerance, 'btn-alchemy-off': !marker.polling.value }">
                                            <span v-if="marker.polling.value" :title="`Ping | Success: ${marker.ping.success}% | Loss: ${marker.ping.loss}% | RTT: ${marker.ping.rtt} | Latency: ${marker.ping.latency} | Jitter: ${marker.ping.jitter}`">{{marker.ping.success}}% | {{marker.ping.latency}} ms | {{marker.ping.jitter}} ms</span>
                                            <span v-if="!marker.polling.value" title="Inactive polling.">-</span>
                                        </button>
                                    </td>
                                    <!-- CPU -->
                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button v-if="marker.polling.value && marker.cpu.exec" style="font-size: 13px;" class="btn fw-light w-100" :title="`CPU | Usage: ${marker.cpu.value}% | Tolerance: ${marker.cpu.tolerance}%`"
                                        :class="{'btn-alchemy-success': marker.cpu.value < marker.cpu.tolerance, 'btn-alchemy-danger': marker.cpu.value >= marker.cpu.tolerance }">
                                            {{marker.cpu.value}}%
                                        </button>
                                        <button v-if="!marker.polling.value || !marker.cpu.exec" style="font-size: 13px;" class="btn btn-alchemy-off fw-light w-100">
                                            -
                                        </button>
                                    </td>
                                    <!-- Memory -->
                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button v-if="marker.polling.value && marker.memory.exec" style="font-size: 13px;" class="btn fw-light w-100" :title="`Memory | Usage: ${marker.memory.value}% | Tolerance: ${marker.memory.tolerance}%`"
                                        :class="{'btn-alchemy-success': marker.memory.value < marker.memory.tolerance, 'btn-alchemy-danger': marker.memory.value >= marker.memory.tolerance }">
                                            {{marker.memory.value}}%
                                        </button>
                                        <button v-if="!marker.polling.value || !marker.memory.exec" style="font-size: 13px;" class="btn btn-alchemy-off fw-light w-100">
                                            -
                                        </button>
                                    </td>
                                    <!-- All Targets -->
                                    <td class="text-center bg-black" style="width: 12%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button v-if="marker.polling.value" style="font-size: 13px;" class="btn fw-light w-100" data-bs-toggle="modal" data-bs-target="#deviceDetail"  @click="viewMarker(marker, 'targets');"
                                            :class="{ 'btn-alchemy-success': marker.targets.exec_targets, 'btn-alchemy-off': !marker.targets.exec_targets }">
                                            <span :title="`Total targets: ${marker.targets.total}\nUp targets: ${marker.targets.up}\nNot up targets: ${marker.targets.notup}`" v-if="marker.targets.exec_targets">{{ marker.targets.total }} | {{marker.targets.up}} | {{marker.targets.notup}}</span>
                                            <span title="Inactive targets monitoring." v-if="!marker.targets.exec_targets">-</span>
                                        </button>
                                        <button v-if="!marker.polling.value" style="font-size: 13px;" class="btn btn-alchemy-off fw-light w-100" title="Inactive target polling.">
                                            -
                                        </button>
                                    </td>
                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);" title="Alerts">
                                        <button class="btn fw-light w-100" style="font-size: 13px;" data-bs-toggle="modal" data-bs-target="#deviceDetail"  @click="viewMarker(marker, 'alerts');" :class="{'btn-alchemy-dark bg-gradient': marker.alerts.length == 0, 'btn-alchemy-danger': marker.alerts.length > 0}">
                                            {{marker.alerts.length}}
                                        </button>
                                    </td>
                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50);">
                                        <button class="btn btn-alchemy-dark bg-gradient fw-light w-100" style="font-size: 13px;" data-bs-toggle="modal" data-bs-target="#deviceDetail" @click="viewMarker(marker)" :disabled="autoRefresh || marker.is_new">
                                            <i class="fa-solid fa-lg fa-eye"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Map & Marker View -->  
            <div class="col-md-11" v-show="sectionView=='map'">
                <div v-if="false" class="input-group flex-nowrap">
                    <input class="btn fw-light bg-alchemy fs-6 w-25" type="text" style="cursor: default;" placeholder="Filter IP, hostname or alias." v-model="searchWord">
                    <input class="btn fw-light bg-alchemy bg-gradient fs-6 me-1 text-start" type="text" style="cursor: default; opacity: 1; width: 15%;" v-model="statusTimestamp" disabled>
                    <input class="btn fw-light bg-alchemy bg-gradient fs-6 w-75 text-start" type="text" style="cursor: default;" v-model="statusText" readonly>
                </div>

                <div class="input-group flex-nowrap">
                    <input class="btn fw-light bg-alchemy fs-6 w-25" type="text" style="cursor: default;" placeholder="Search by..." v-model="searchWord">
                    <select class="btn fw-light bg-alchemy bg-gradient fs-6 text-start rounded w-25" v-model="search_std_type">
                        <option value="name">By Name</option>
                        <option value="alias">By Alias</option>
                        <option value="ip">By IP Address</option>
                        <option value="os">By OS</option>
                        <option value="role">By Role</option>
                    </select>
                    <div style="width: 50%;"></div>
                    <button class="btn fs-6 rounded" :class="{'bg-alchemy-success': only_active, 'bg-alchemy bg-gradient': !only_active}" @click="only_active = !only_active">
                        <i class="fa-solid fa-xl fa-power-off"></i>
                    </button>
                </div>
                
                <!-- Map with Markers -->
                <div v-if="!mapKey || gettingMarkers" class="p-2 bg-alchemy rounded mt-1" style="height: 535px;">
                    <button class="btn bg-alchemy fs-2" style="margin-top: 14%;">
                        <i class="fa-solid fa-xl fa-globe fa-beat"></i>
                        <div>Getting map and markers...</div>
                    </button>
                </div>
                <div v-if="mapKey && !gettingMarkers" class="p-1 bg-alchemy-two rounded mt-1" :class="{'disabled-div': gettingMarkers}">
                    <MapViewer :key="markerMapKey" mapHeight="535" :markers="filteredMarkers" :icons="icons" :centerLatitude="centerLatitute" :centerLongitude="centerLongitude" :zoom="zoom" :mapKey="mapKey"/>
                </div>
            </div> 
        </div>
        <!-- CLOUD DEVICES -->
        <div v-if="dvmode=='cloud_devices'" class="row">
            <div class="col-md-1">
                <div class="bg-alchemy-two bg-gradient p-2 rounded" style="height: 585px;" :class="{'disabled-div': cloud_mode != 'table'}">
                    <button class="btn fs-3 text-white">
                        <i class="fa-solid fa-xl fa-cloud"></i>
                    </button>
                    <button  class="btn btn-alchemy fs-3 w-100 mt-2" @click="clearCloudMonitoring">
                        <i class="fa-solid fa-xl fa-arrows-rotate" :class="{'fa-spin': getting_cloud_markers }"></i>
                    </button>
                    <button  class="btn fs-3 w-100 mt-2" :class="{'btn-alchemy': !focus_mode, 'bg-alchemy': focus_mode}" @click="focus_mode = !focus_mode">
                        <i class="fa-solid fa-xl fa-lightbulb"></i>
                    </button>
                    <button v-if="false" class="btn btn-alchemy w-100 mt-2">
                        <i class="fa-solid fa-xl fa-file-excel"></i>
                    </button>
                </div>
            </div>
            <div class="col-md-11">
                <!-- Filter & controls -->
                <div v-if="cloud_mode == 'table'">
                    <!-- Filter & controls -->
                    <div class="input-group flex-nowrap">
                        <select class="btn fw-light bg-alchemy bg-gradient fs-6 text-start rounded" style="width: 30%" v-model="cloud_dtype" @change="setCloudMarkers" :disabled="getting_cloud_markers">
                            <option v-if="Object.keys(all_cloud_markers).includes('accesspoint')" value="accesspoint">Access Points ({{all_cloud_markers.accesspoint.length}})</option>
                            <option v-if="Object.keys(all_cloud_markers).includes('firewall')" value="firewall">Firewalls ({{all_cloud_markers.firewall.length}})</option>
                        </select>
                        <input class="btn fw-light bg-alchemy fs-6 w-25 border-bottom-alchemy" type="text" style="cursor: default;" placeholder="Search by..." v-model="search_cloud_word">
                        <select class="btn fw-light bg-alchemy bg-gradient fs-6 text-start rounded w-25" v-model="search_cloud_type">
                            <option value="name">By Name</option>
                            <option value="alias">By Alias</option>
                            <option value="mac">By MAC Address</option>
                            <option value="os">By OS</option>
                            <option value="role">By Role</option>
                        </select>
                        <div style="width: 20%;"></div>
                        <button class="btn fs-6 rounded me-2" :class="{'bg-alchemy-success': only_active, 'bg-alchemy bg-gradient': !only_active}" @click="only_active = !only_active">
                            <i class="fa-solid fa-xl fa-power-off"></i>
                        </button>
                        <select v-if="cloud_dtype=='accesspoint'" class="btn fw-light bg-alchemy bg-gradient fs-6 text-start rounded" style="width: 30%;" v-model="cloud_devices_sorter" @change="refreshCloudSorter">
                            <option :value="null">Sorting</option>
                            <option value="ce_desc">Connected Endpoints (Desc)</option>
                            <option value="rxkbps_desc">Input in Kbps (Desc)</option>
                            <option value="txkbps_desc">Output in Kbps (Desc)</option>
                            <option value="alerts_desc">Alerts (Desc)</option>
                        </select>
                        <select v-if="cloud_dtype=='firewall'" class="btn fw-light bg-alchemy bg-gradient fs-6 text-start rounded" style="width: 30%;" v-model="cloud_devices_sorter" @change="refreshCloudSorter">
                            <option :value="null">Sorting</option>
                            <option value="alerts_desc">Alerts (Desc)</option>
                        </select>
                    </div>
                    <!-- Tables -->
                    <div :class="{'disabled-div': getting_cloud_markers}">
                        <!-- ACCESS POINT Table -->
                        <div v-if="cloud_dtype == 'accesspoint'" class="mt-1" >
                            <!-- Header -->
                            <div class="input-group flex-nowrap mb-2" style="overflow-y: scroll;">
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 7%;" title="Role">
                                    <i class="fa-solid fa-lg fa-cube"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 7%;" title="Operating System">
                                    OS
                                </button>
                                <select class="btn btn-alchemy fs-5 me-1" style="width: 25%;" v-model="search_cloud_type" title="Data">
                                    <option value="name">Hostname</option>
                                    <option value="alias">Alias</option>
                                    <option value="mac">MAC Address</option>
                                    <option value="os">OS</option>
                                    <option value="role">Role</option>
                                </select>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 5%;" title="Status">
                                    <i class="fa-solid fa-lg fa-heart"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 5%;" title="Connectivity">
                                    <i class="fa-solid fa-lg fa-signal"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 5%;" title="Connected Endpoints">
                                    <i class="fa-solid fa-lg fa-link"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 5%;" title="Radios">
                                    <i class="fa-solid fa-lg fa-wifi"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 20%;" title="Vendor Specific">
                                    <i class="fa-solid fa-lg fa-box"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 10%;" title="TX / RX Kbps">
                                    <i class="fa-solid fa-lg fa-arrow-down"></i>
                                    /
                                    <i class="fa-solid fa-lg fa-arrow-down"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 5%;" title="Vendor Specific">
                                    <i class="fa-solid fa-lg fa-triangle-exclamation"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 5%;" title="Details">
                                    <i class="fa-solid fa-lg"></i>
                                </button>
                            </div>
                            <!-- Content -->
                            <div class="" style="overflow-y: scroll; height: 490px;">
                                <div class="input-group flex-nowrap mb-1" :class="{'element-hover': focus_mode}" v-for="(cl_marker, clmi) in filtered_cloud_markers" v-bind:key="clmi+1">
                                    <button class="btn bg-alchemy bg-gradient fs-6 me-1">
                                        <img id="roleimg" :src="getImage(cl_marker.role)" :title="String(cl_marker.role).toUpperCase()" :alt="cl_marker.role" width="65" class="img-fluid rounded border-0">
                                    </button>
                                    <button class="btn bg-alchemy bg-gradient fs-4 me-1" style="width: 7%;" title="Operating System">
                                        <img :src="getImage(oss[cl_marker.os])" :title="String(oss[cl_marker.os]).toUpperCase()" width="65" class="img-fluid rounded border-0">
                                    </button>
                                    <input readonly type="text" class="btn bg-alchemy bg-gradient fs-6 me-1" :value="String(cl_marker[search_cloud_type]).toUpperCase()" style="width: 25%; pointer-events: none;" title="Data">
                                    <button class="btn fs-4 me-1" :class="{'btn-alchemy': cl_marker.status == 'up', 'bg-alchemy-danger': cl_marker.status == 'down', 'bg-alchemy bg-gradient': cl_marker.status == null}" style="width: 5%;" :title="`Status: ${String(cl_marker.status).toUpperCase()}`">
                                        <i v-if="cl_marker.status == 'up'" class="fa-solid fa-lg fa-check"></i>
                                        <i v-if="cl_marker.status == 'down'" class="fa-solid fa-lg fa-close"></i>
                                        <i v-if="cl_marker.status == null" class="fa-solid fa-lg fa-question"></i>
                                    </button>
                                    <button class="btn fs-4 me-1" :class="{'btn-alchemy': cl_marker.connectivity == 1, 'bg-alchemy-danger': cl_marker.connectivity != 1 }" style="width: 5%;" :title="`Connectivity: ${cl_marker.connectivity == 1 ? 'YES' : 'NO'}`">
                                        <i v-if="cl_marker.connectivity == 1" class="fa-solid fa-lg fa-check"></i>
                                        <i v-if="cl_marker.connectivity == 0" class="fa-solid fa-lg fa-close"></i>
                                        <i v-if="cl_marker.connectivity == null" class="fa-solid fa-lg fa-question"></i>
                                    </button>
                                    <button class="btn fs-5 me-1" :class="{'btn-alchemy': cl_marker.connected_endpoints != null, 'bg-alchemy bg-gradient': cl_marker.connected_endpoints == null }" style="width: 5%;" title="Connected Endpoints">
                                        {{cl_marker.connected_endpoints != null ? cl_marker.connected_endpoints : '-'}}
                                    </button>
                                    <button class="btn bg-alchemy bg-gradient fs-5 me-1" style="width: 5%;" title="Radios">
                                        {{cl_marker.radios.length > 0 ? cl_marker.radios.length : '-'}} 
                                    </button>
                                    <select class="btn bg-alchemy bg-gradient fs-6 me-1" style="width: 20%;" title="Vendor Specific">
                                        <option value="" v-for="(vsv, vsk, vsi) in cl_marker.vendor_specific" v-bind:key="vsi+1">{{`${capitalize(vsk.replace('_',' '))} : ${vsv} ${vendor_sp[vsk]}`}}</option>
                                    </select>
                                    <button class="btn bg-alchemy bg-gradient fs-6 me-1" style="width: 10%;" title="TX / RX Kbps">
                                        {{typeof(cl_marker.tx_kbps) == 'number' ? cl_marker.tx_kbps : '-'}}
                                        /
                                        {{typeof(cl_marker.rx_kbps) == 'number' ? cl_marker.rx_kbps : '-'}}
                                    </button>
                                    <button class="btn bg-alchemy bg-gradient fs-4 me-1" style="width: 5%;" title="Alerts">
                                        {{cl_marker.alerts.length > 0 ? cl_marker.alerts.length : '-'}}
                                    </button>
                                    <button class="btn bg-alchemy bg-gradient fs-4 me-1" style="width: 5%;" title="Device Detail" @click="cloud_device=cl_marker; cloud_mode='cloud_dev_detail'; cloud_history_mode='device'; setNow();" :disabled="autoRefresh">
                                        <i class="fa-solid fa-lg fa-right-to-bracket"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- SWITCH Table -->
                        <div v-if="cloud_dtype == 'switch'">
                            <p>SWITCHS</p>
                        </div>
                        <!-- FIREWALL Table -->
                        <div v-if="cloud_dtype == 'firewall'" class="mt-1">
                            <!-- Header -->
                            <div class="input-group flex-nowrap mb-2" style="overflow-y: scroll;">
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 7%;" title="Role">
                                    <i class="fa-solid fa-lg fa-cube"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 7%;" title="Operating System">
                                    OS
                                </button>
                                <select class="btn btn-alchemy fs-5 me-1" style="width: 40%;" v-model="search_cloud_type" title="Data">
                                    <option value="name">Hostname</option>
                                    <option value="alias">Alias</option>
                                    <option value="mac">MAC Address</option>
                                    <option value="os">OS</option>
                                    <option value="role">Role</option>
                                </select>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 5%;" title="Status">
                                    <i class="fa-solid fa-lg fa-heart"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 5%;" title="Connectivity">
                                    <i class="fa-solid fa-lg fa-signal"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 25%;" title="Vendor Specific">
                                    <i class="fa-solid fa-lg fa-box"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 5%;" title="Alerts">
                                    <i class="fa-solid fa-lg fa-triangle-exclamation"></i>
                                </button>
                                <button class="btn btn-alchemy fs-5 me-1" style="width: 5%;" title="Details">
                                    <i class="fa-solid fa-lg"></i>
                                </button>
                            </div>
                            <!-- Content -->
                            <div class="" style="overflow-y: scroll; height: 490px;">
                                <div class="input-group flex-nowrap mb-1" :class="{'element-hover': focus_mode}" v-for="(cl_marker, clmi) in filtered_cloud_markers" v-bind:key="clmi+1">
                                    <button class="btn bg-alchemy bg-gradient fs-6 me-1">
                                        <img id="roleimg" :src="getImage(cl_marker.role)" :title="String(cl_marker.role).toUpperCase()" :alt="cl_marker.role" width="65" class="img-fluid rounded border-0">
                                    </button>
                                    <button class="btn bg-alchemy bg-gradient fs-4 me-1" style="width: 7%;" title="Operating System">
                                        <img :src="getImage(oss[cl_marker.os])" :title="String(oss[cl_marker.os]).toUpperCase()" width="65" class="img-fluid rounded border-0">
                                    </button>
                                    <input readonly type="text" class="btn bg-alchemy bg-gradient fs-6 me-1" :value="String(cl_marker[search_cloud_type]).toUpperCase()" style="width: 40%; pointer-events: none;" title="Data">
                                    <button class="btn fs-4 me-1" :class="{'btn-alchemy': cl_marker.status == 'up', 'bg-alchemy-danger': cl_marker.status == 'down', 'bg-alchemy bg-gradient': cl_marker.status == null}" style="width: 5%;" :title="`Status: ${String(cl_marker.status).toUpperCase()}`">
                                        <i v-if="cl_marker.status == 'up'" class="fa-solid fa-lg fa-check"></i>
                                        <i v-if="cl_marker.status == 'down'" class="fa-solid fa-lg fa-close"></i>
                                        <i v-if="cl_marker.status == null" class="fa-solid fa-lg fa-question"></i>
                                    </button>
                                    <button class="btn fs-4 me-1" :class="{'btn-alchemy': cl_marker.connectivity == 1, 'bg-alchemy-danger': cl_marker.connectivity != 1 }" style="width: 5%;" :title="`Connectivity: ${cl_marker.connectivity == 1 ? 'YES' : 'NO'}`">
                                        <i v-if="cl_marker.connectivity == 1" class="fa-solid fa-lg fa-check"></i>
                                        <i v-if="cl_marker.connectivity == 0" class="fa-solid fa-lg fa-close"></i>
                                        <i v-if="cl_marker.connectivity == null" class="fa-solid fa-lg fa-question"></i>
                                    </button>
                                    
                                    <select class="btn bg-alchemy bg-gradient fs-6 me-1" style="width: 25%;" title="Vendor Specific">
                                        <option value="" v-for="(vsv, vsk, vsi) in cl_marker.vendor_specific" v-bind:key="vsi+1">{{`${capitalize(vsk.replace('_',' '))} : ${vsv} ${vendor_sp[vsk]}`}}</option>
                                    </select>
                                    <button class="btn bg-alchemy bg-gradient fs-4 me-1" style="width: 5%;" title="Alerts">
                                        {{cl_marker.alerts.length > 0 ? cl_marker.alerts.length : '-'}}
                                    </button>
                                    <button class="btn bg-alchemy bg-gradient fs-4 me-1" style="width: 5%;" title="Device Detail" @click="cloud_device=cl_marker; cloud_mode='cloud_dev_detail'; cloud_history_mode='device'; setNow();" :disabled="autoRefresh">
                                        <i class="fa-solid fa-lg fa-right-to-bracket"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="cloud_mode == 'cloud_dev_detail'">
                    <div v-if="cloud_device != null">
                        <!-- ACCESS POINT Detail -->
                        <div v-if="cloud_dtype == 'accesspoint'">
                            <!-- ACCESS POINT Detail Header -->
                            <div class="input-group flex-nowrap">
                                <button class="btn btn-alchemy-dark fs-5 me-1" title="Cloud Device Name">
                                    <i class="fa-solid fa-xl fa-cloud text-primary"></i>
                                </button>
                                <input type="text" :value="cloud_device.name" title="Device Name" class="btn fw-light text-start fw-light bg-alchemy fs-4 w-50" style="letter-spacing: 3px;" readonly>
                                <button class="btn fs-5 rounded me-1" :class="{'bg-alchemy border-alchemy bg-gradient': cloud_device_mode == 'info', 'bg-alchemy bg-gradient': cloud_device_mode != 'info'}" style="width: 7%;" title="Device Info" @click="cloud_device_mode = 'info'">
                                    <i class="fa-solid fa-xl fa-info text-primary"></i>
                                </button>
                                <button class="btn bg-gradient fs-5 rounded me-1" :class="{'bg-alchemy border-alchemy bg-gradient': cloud_device_mode == 'health', 'bg-alchemy bg-gradient': cloud_device_mode != 'health'}" style="width: 7%;" title="Device Health" @click="cloud_device_mode = 'health'">
                                    <i class="fa-solid fa-xl fa-heart text-danger"></i>
                                </button>
                                <button class="btn bg-gradient fs-5 rounded me-1" :class="{'bg-alchemy border-alchemy bg-gradient': cloud_device_mode == 'graph', 'bg-alchemy bg-gradient': cloud_device_mode != 'graph'}" style="width: 7%;" title="Device History" @click="cloud_device_mode='graph'; cloud_history_mode='device'; cloud_device_graph_type=null;">
                                    <i class="fa-solid fa-xl fa-chart-line text-info"></i>
                                </button>
                                <button class="btn bg-gradient fs-5 rounded me-1" :class="{'bg-alchemy border-alchemy bg-gradient': cloud_device_mode == 'events', 'bg-alchemy bg-gradient': cloud_device_mode != 'events'}" style="width: 7%;" title="Device Alerts" @click="cloud_device_mode = 'events'; cloud_device_events=null;">
                                    <i class="fa-solid fa-xl fa-calendar-day text-secondary"></i>
                                </button>
                                <button class="btn bg-gradient fs-5 rounded" :class="{'bg-alchemy border-alchemy bg-gradient': cloud_device_mode == 'alerts', 'bg-alchemy bg-gradient': cloud_device_mode != 'alerts'}" style="width: 7%;" title="Device Alerts" @click="cloud_device_mode = 'alerts'">
                                    <i class="fa-solid fa-xl fa-bell text-warning"></i>
                                </button>
                                <div class="text-white" style="width: 98%;"></div>
                                <button class="btn bg-alchemy bg-gradient rounded me-1" @click="setCloudDevice('past')" title="Previous device">
                                    <i class="fa-solid fa-xl fa-arrow-left text-primary"></i>
                                </button>
                                <button class="btn bg-gradient bg-alchemy fs-5 rounded me-1" style="width: 15%;" title="Total Devices (Includes filtering)">
                                    {{ filtered_cloud_markers.indexOf(cloud_device) + 1 }}  / {{ filtered_cloud_markers.length }}
                                </button>
                                <button class="btn bg-alchemy bg-gradient rounded me-1" @click="setCloudDevice('next')" title="Next device">
                                    <i class="fa-solid fa-xl fa-arrow-right text-primary"></i>
                                </button>
                                <button class="btn bg-alchemy bg-gradient fs-4 rounded" @click="cloud_mode='table'; cloud_device: null; cloud_device_mode='info'; cloud_device_history = null; cloud_device_radio_graph = null;">
                                    <i class="fa-solid fa-xl fa-close text-danger"></i>
                                </button>
                            </div>
                            <!-- ACCESS POINT Detail Info -->
                            <div v-if="cloud_device_mode == 'info'" class="mt-2">
                                <div class="input-group flex-nowrap mt-3">
                                    <button class="btn bg-alchemy fs-4 me-1" style="width: 13%;">
                                        <i class="fa-solid fa-xl fa-info text-primary"></i>
                                    </button>
                                    <div class="btn bg-alchemy text-white text-start fw-light fs-3" style="width: 91%; letter-spacing: 4px;">Device Information</div>
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <button class="btn bg-alchemy fs-6 me-1" style="width: 13%;">
                                        <img id="roleimg" :src="getImage(cloud_device.role)" :title="String(cloud_device.role).toUpperCase()" :alt="cloud_device.role"  class="img-fluid rounded border-0">
                                        <div>{{String(cloud_device.role).toUpperCase()}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4 me-1" style="width: 30%; letter-spacing: 3px;" title="Device Name">
                                        <i class="fa-solid fa-xl fa-cloud text-primary mb-4"></i>
                                        <div>{{cloud_device.name}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4 me-1" style="width: 30%; letter-spacing: 3px;" title="Device Alias">
                                        <i class="fa-solid fa-xl fa-id-badge text-info mb-4"></i>
                                        <div>{{cloud_device.alias}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4" style="width: 30%; letter-spacing: 3px;" title="Cloud ID">
                                        <i class="fa-solid fa-xl fa-cloud text-primary me-1"></i>
                                        <i class="fa-solid fa-xl fa-i"></i>
                                        <i class="fa-solid fa-xl fa-d mb-4"></i>
                                        <div>{{cloud_device.uid_cloud}}</div>
                                    </button>
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <button class="btn bg-alchemy fs-4 me-1" style="width: 13%;" title="Operating System">
                                        <img :src="getImage(oss[cloud_device.os])" :title="String(oss[cloud_device.os]).toUpperCase()" class="img-fluid rounded border-0">
                                        <div>{{String(cloud_device.os).toUpperCase()}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4 me-1" style="width: 30%; letter-spacing: 3px;" title="MAC Address">
                                        <i class="fa-solid fa-xl fa-m text-secondary"></i>
                                        <i class="fa-solid fa-xl fa-a text-secondary"></i>
                                        <i class="fa-solid fa-xl fa-c text-secondary mb-4"></i>
                                        <div>{{cloud_device.mac}}</div>
                                    </button>
                                    <button class="btn fw-light fs-4 me-1" :class="{'bg-alchemy': cloud_device.active == 1, 'bg-alchemy-danger': cloud_device.active != 1}" style="width: 30%; letter-spacing: 3px;" title="Monitoring permission status">
                                        <i class="fa-solid fa-xl fa-power-off mb-4" :class="{'text-success': cloud_device.active == 1, 'text-dark': cloud_device.active != 1}"></i>
                                        <div>{{cloud_device.active == 1 ? 'Monitoring: ON':'Monitoring: OFF'}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4" style="width: 30%; letter-spacing: 3px;" title="Last Update">
                                        <i class="fa-solid fa-xl fa-calendar text-info mb-4"></i>
                                        <div>{{cloud_device.last_update}}</div>
                                    </button>
                                </div>
                            </div>
                            <!-- ACCESS POINT Detail Health -->
                            <div v-if="cloud_device_mode == 'health'">
                                <div class="input-group flex-nowrap mt-3">
                                    <button class="btn bg-alchemy fs-4 me-1" style="width: 13%;">
                                        <i class="fa-solid fa-xl fa-heart text-danger"></i>
                                    </button>
                                    <div class="btn bg-alchemy text-white text-start fw-light fs-3" style="width: 91%; letter-spacing: 4px;">Device Health</div>
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <button class="btn fw-light fs-4 me-1" :class="{'bg-alchemy': cloud_device.status == 'up', 'bg-alchemy-danger': cloud_device.status != 'up'}"  style="width: 25%; letter-spacing: 3px;">
                                        <i class="fa-solid fa-xl fa-heart mb-4" :class="{'text-info': cloud_device.status == 'up', 'text-black fa-beat-fade': cloud_device.status != 'up'}"></i>
                                        <div>{{cloud_device.status == 'up' ? 'Status: UP':'Status: '+String(cloud_device.status).toUpperCase()}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4 me-1" style="width: 35%; letter-spacing: 3px;">
                                        <i class="fa-solid fa-xl fa-signal mb-4" :class="{'text-primary': cloud_device.connectivity == 1, 'text-danger fa-fade': cloud_device.connectivity != 1}"></i>
                                        <div>{{cloud_device.connectivity == 1 ? 'Connectivity: YES':'Connectivity: NO'}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4" style="width: 40%; letter-spacing: 3px;">
                                        <i class="fa-solid fa-xl fa-link mb-4" :class="{'text-primary': cloud_device.connected_endpoints != null, 'text-warning fa-fade': cloud_device.connected_endpoints == null}"></i>
                                        <div>{{cloud_device.connected_endpoints != null ? `Connected endpoints: ${cloud_device.connected_endpoints}`:'No endpoints connected.'}}</div>
                                    </button>
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <div class="btn bg-alchemy-two fw-light fs-4 me-1" style="width: 70%; height: 350px; overflow-y: scroll; letter-spacing: 3px; cursor: default;">
                                        <i class="fa-solid fa-xl fa-wifi text-primary"></i>
                                        <div>Radios: {{cloud_device.radios.length}}</div>
                                        <div v-for="(radio, ri) in cloud_device.radios" v-bind:key="ri+1">
                                            <div class="input-group flex-nowrap bg-black rounded mt-2">
                                                <button class="btn me-1" style="width: 5%;" title="SSID Icon">
                                                    <i class="fa-solid fa-xl fa-wifi" :class="{'text-primary': radio.status == 'up', 'text-danger': radio.status != 'up'}"></i>
                                                </button>
                                                <button class="btn fs-5 text-white text-start" style="width: 5%;" title="Total SSIDS">
                                                    {{radio.ssids.length}}
                                                </button>
                                                <select class="btn fs-5 text-white text-start me-3" style="width: 35%;">
                                                    <option value="" v-for="(ssid, si) in radio.ssids" v-bind:key="si+1">{{ssid}}</option>
                                                </select>
                                                <button class="btn me-1" style="width: 4%;" title="Radio MAC Address">
                                                    <i class="fa-solid fa-xl fa-id-badge text-info"></i>
                                                </button>
                                                <button class="btn fs-5 text-white text-start" style="width: 30%;" title="Radio MAC Address">
                                                    {{radio.mac}} 
                                                </button>
                                                <div class="width: 70%;"></div>
                                            </div>
                                            <div class="input-group flex-nowrap bg-black rounded">
                                                <button class="btn me-1" style="width: 5%;" title="Band in GHz">
                                                    <i class="fa-solid fa-xl fa-tower-broadcast" :class="{'text-primary': radio.status == 'up', 'text-danger': radio.status != 'up'}"></i>
                                                </button>
                                                <button class="btn fs-5 text-white text-start" style="width: 15%;" title="Band in GHz">
                                                    {{radio.band_ghz}} GHz 
                                                </button>
                                                <button class="btn me-1" style="width: 5%;" title="Width in MHz">
                                                    <i class="fa-solid fa-xl fa-ruler-horizontal text-primary"></i>
                                                </button>
                                                <button class="btn fs-5 text-white text-start" style="width: 15%;" title="Width in MHz">
                                                    {{radio.width_mhz}} MHz
                                                </button>
                                                <button class="btn me-1" style="width: 3%;" title="Status Icon">
                                                    <i class="fa-solid fa-xl" :class="{'fa-check text-success': radio.status == 'up', 'fa-close text-danger': radio.status != 'up'}"></i>
                                                </button>
                                                <button class="btn fs-5 text-white text-start me-5" style="width: 10%;" title="Band in GHz">
                                                    {{String(radio.status).toUpperCase()}}
                                                </button>
                                                <button class="btn me-1" style="width: 5%;" title="Percentage Icon">
                                                    <i class="fa-solid fa-percentage text-info fa-xl"></i>
                                                </button>
                                                <button class="btn fs-5 text-white text-start" style="width: 15%;" title="Percentage">
                                                    {{typeof(radio.percentage) == 'number' ? radio.percentage : '-' }}
                                                </button>
                                                <button class="btn me-1" style="width: 5%;" title="Channel Number Icon">
                                                    <i class="fa-solid fa-xl fa-hashtag text-info"></i>
                                                </button>
                                                <button class="btn fs-5 text-white text-start" style="width: 10%;" title="Channel Number">
                                                    {{radio.number_channel}} 
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="btn bg-alchemy-two fw-light fs-4" style="width: 40%; height: 350px; overflow-y: scroll; letter-spacing: 3px; cursor: default;">
                                        <i class="fa-solid fa-xl fa-leaf text-success"></i>
                                        <div>Vendor Specific</div>
                                        <div v-for="(vsv, vsk, vsi) in cloud_device.vendor_specific" v-bind:key="vsi+1">
                                            <div class="input-group flex-nowrap bg-black border-bottom-alchemy rounded mt-2">
                                                <button class="btn">
                                                    <i class="fa-solid fa-xl fa-box text-primary"></i>
                                                </button>
                                                <button class="btn fs-5 text-white text-start" style="width: 90%;">
                                                    {{capitalize(vsk.replace('_',' '))}}
                                                </button>
                                                <button class="btn fs-5 text-white">
                                                    {{vsv}}
                                                </button>
                                                <button class="btn fs-5 text-white">
                                                    {{ Object.keys(vendor_sp).includes(vsk) ? vendor_sp[vsk] : '-' }}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- ACCESS POINT Detail Graph -->
                            <div v-if="cloud_device_mode == 'graph'">
                                <div class="input-group flex-nowrap mt-3">
                                    <button class="btn bg-alchemy fs-4 me-1" style="width: 13%;">
                                        <i v-if="cloud_history_mode == 'radios'" class="fa-solid fa-xl fa-wifi text-primary me-2"></i>
                                        <i class="fa-solid fa-xl fa-chart-line text-info"></i>
                                    </button>
                                    <select class="btn bg-alchemy text-white text-start fw-light rounded fs-4" style="width: 28%; letter-spacing: 4px;" v-model="cloud_history_mode" @change="cloud_device_graph_type = null;">
                                        <option :value="'device'">Device History</option>
                                        <option :value="'radios'">Radios History</option>
                                    </select>
                                     <!-- ACCESS POINT Interval Start -->
                                    <button class="btn bg-alchemy fs-5 rounded ms-3" style="cursor: default; border-right: solid 3px black; width: 5%;" :disabled="getting_cloud_history">
                                        <i class="fa-solid fa-xl fa-hourglass-start text-success"></i>
                                    </button>
                                    <input type="date" class="btn bg-alchemy text-white fs-6 me-1" style="width: 13%; color-scheme: dark;" v-model="cl_start.date" :disabled="getting_cloud_history">
                                    <input type="time" class="btn bg-alchemy text-white fs-6 rounded" style="width: 12%; color-scheme: dark;" v-model="cl_start.time" :disabled="getting_cloud_history">
                                    <!-- ACCESS POINT Interval End -->
                                    <button class="btn bg-alchemy fs-5 rounded ms-3" style="border-right: solid 3px black; width: 5%;" @click="setNow" :disabled="getting_cloud_history">
                                        <i class="fa-solid fa-xl fa-hourglass-end text-danger"></i>
                                    </button>
                                    <input type="date" class="btn bg-alchemy text-white fs-6" style="width: 13%; color-scheme: dark;" v-model="cl_end.date" :disabled="getting_cloud_history">
                                    <input type="time" class="btn bg-alchemy text-white fs-6 rounded" style="width: 12%; color-scheme: dark;" v-model="cl_end.time" :disabled="getting_cloud_history">
                                    <!-- ACCESS POINT Interval Search -->
                                    <button class="btn bg-alchemy fs-4 rounded ms-3" style="width: 5%;" @click="getCloudDeviceHistory(true)">
                                        <i class="fa-solid fa-xl fa-search text-info"></i>
                                    </button>
                                </div>
                                <div class="bg-alchemy-two fw-light fs-4 mt-1 w-100 p-1" style="height: 460px; overflow-y: hidden;">
                                    <div v-if="cloud_device_history == null">
                                        <div class="" style="margin-top: 15%;">
                                            <i class="fa-solid fa-xl fs-1 fa-chart-line fa-fade text-info" :class="{'fa-beat-fade': getting_cloud_history}"></i>
                                            <div v-if="!getting_cloud_history" class="text-white" style="letter-spacing: 3px;">...</div>
                                            <div v-if="getting_cloud_history" class="text-white" style="letter-spacing: 3px;">Searching history, please wait...</div>
                                        </div>
                                    </div>
                                    <div v-if="cloud_device_history != null && cloud_history_mode == 'device'">
                                        <div class="input-group flex-nowrap">
                                            <button class="btn bg-black text-start text-info fs-5 border-bottom-alchemy rounded me-2" @click="getCloudDeviceReport();" title="Get device report." :disabled="getting_cd_report">
                                                <i class="fa-solid fa-xl fa-file-excel text-info" :class="{'fa-beat-fade': getting_cd_report}"></i>
                                            </button>
                                            <select  class="btn bg-black text-start text-info fs-5 border-bottom-alchemy rounded" v-model="cloud_device_graph_type">
                                                <option :value="null">Status</option>
                                                <option value="rates">TX/RX in Kbps</option>
                                                <option value="vendor_sp">Latency AVG</option>
                                            </select>
                                        </div>
                                        <div v-if="cloud_device_graph_type==null">
                                            <StatusGraph chart-id="cloud_ap_status_graph" :chart-data="cloud_device_history.device.status"></StatusGraph>
                                        </div>
                                        <div v-if="cloud_device_graph_type=='rates'">
                                            <CloudAPRates chart-id="cloud_ap_rates_graph" :chart-data="cloud_device_history.device.rates"></CloudAPRates>
                                        </div>
                                        <div v-if="cloud_device_graph_type=='vendor_sp'">
                                            <CloudAPVSP chart-id="cloud_ap_vsp_graph" :chart-data="cloud_device_history.device.vendor_sp"></CloudAPVSP>
                                        </div>
                                    </div>
                                    <div v-if="cloud_device_history != null && cloud_history_mode == 'radios'">
                                        <div class="input-group flex-nowrap">
                                            <button class="btn bg-black text-start text-info fs-5 border-bottom-alchemy rounded me-1" @click="getCloudDeviceReport();" :disabled="cloud_device_radio_graph == null || getting_cd_report">
                                                <i class="fa-solid fa-xl fa-file-excel text-info" :class="{'fa-beat-fade': getting_cd_report}"></i>
                                            </button>
                                            <select  class="btn bg-black text-start text-info fs-5 border-bottom-alchemy rounded me-1" v-model="cloud_device_radio_graph">
                                                <option :value="null">Radios...</option>
                                                <option :value="radio_graph" v-for="(radio_graph, rgi) in cloud_device_history.radios" v-bind:key="rgi+1">{{`Band: ${radio_graph.band_ghz} GHz, MAC: ${radio_graph.mac}`}}</option>
                                            </select>
                                            <select  class="btn bg-black text-start text-info fs-5 border-bottom-alchemy rounded" v-model="cloud_device_graph_type">
                                                <option :value="null">Percentage</option>
                                                <option value="av">Availability</option>
                                            </select>
                                        </div>
                                        <div v-if="cloud_device_radio_graph == null">
                                            <div class="" style="margin-top: 12%;">
                                                <i class="fa-solid fa-xl fs-1 fa-wifi fa-fade text-primary" :class="{'fa-beat-fade': getting_cloud_history}"></i>
                                                <div class="text-white" style="letter-spacing: 3px;">Select a radio</div>
                                            </div>
                                        </div>
                                        <div v-if="cloud_device_radio_graph != null">
                                            <div v-if="cloud_device_graph_type==null">
                                                <CloudAPRadioPerc chart-id="cloud_ap_radio_perc" :chart-data="cloud_device_radio_graph.graph.perc"></CloudAPRadioPerc>
                                            </div>
                                            <div v-if="cloud_device_graph_type=='av'">
                                                <CloudAPRadioAv chart-id="cloud_ap_radio_av" :chart-data="cloud_device_radio_graph.graph.av"></CloudAPRadioAv>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- ACCESS POINT Detail Events -->
                            <div v-if="cloud_device_mode == 'events'">
                                <div class="input-group flex-nowrap mt-3">
                                    <button class="btn bg-alchemy fs-4 me-1" style="width: 13%;">
                                        <i class="fa-solid fa-xl fa-calendar-day text-secondary"></i>
                                    </button>
                                    <input type="text" class="btn bg-alchemy text-white text-start fw-light rounded fs-3" style="width: 14%; letter-spacing: 4px; pointer-events: none;" value="Events" readonly>
                                    <select class="btn bg-alchemy text-white text-start text-secondary fs-5 rounded" v-model="cloud_device_event_type">
                                        <option :value="null">Timeline</option>
                                        <option value="list">List</option>
                                    </select>
                                    <!-- ACCESS POINT Interval Start -->
                                    <button class="btn bg-alchemy fs-5 rounded ms-3" style="cursor: default; border-right: solid 3px black; width: 5%;" :disabled="getting_cloud_history">
                                        <i class="fa-solid fa-xl fa-hourglass-start text-success"></i>
                                    </button>
                                    <input type="date" class="btn bg-alchemy text-white fs-6 me-1" style="width: 13%; color-scheme: dark;" v-model="cl_start.date" :disabled="getting_cloud_history">
                                    <input type="time" class="btn bg-alchemy text-white fs-6 rounded" style="width: 12%; color-scheme: dark;" v-model="cl_start.time" :disabled="getting_cloud_history">
                                    <!-- ACCESS POINT Interval End -->
                                    <button class="btn bg-alchemy fs-5 rounded ms-3" style="border-right: solid 3px black; width: 5%;" @click="setNow" :disabled="getting_cloud_history">
                                        <i class="fa-solid fa-xl fa-hourglass-end text-danger"></i>
                                    </button>
                                    <input type="date" class="btn bg-alchemy text-white fs-6" style="width: 13%; color-scheme: dark;" v-model="cl_end.date" :disabled="getting_cloud_history">
                                    <input type="time" class="btn bg-alchemy text-white fs-6 rounded" style="width: 12%; color-scheme: dark;" v-model="cl_end.time" :disabled="getting_cloud_history">
                                    <!-- ACCESS POINT Interval Search -->
                                    <button class="btn bg-alchemy fs-4 rounded ms-3" style="width: 5%;" @click="getCloudDeviceEvents(true)">
                                        <i class="fa-solid fa-xl fa-search text-info"></i>
                                    </button>
                                </div>
                                <div class="bg-alchemy-two fw-light fs-4 mt-1 w-100 p-2" style="height: 460px; overflow-y: hidden;">
                                    <div v-if="cloud_device_events == null">
                                        <div class="" style="margin-top: 15%;">
                                            <i class="fa-solid fa-xl fs-1 fa-calendar fa-fade text-secondary" :class="{'fa-beat-fade': getting_cloud_events}"></i>
                                            <div v-if="!getting_cloud_events" class="text-white" style="letter-spacing: 3px;">...</div>
                                            <div v-if="getting_cloud_events" class="text-white" style="letter-spacing: 3px;">Searching events, please wait...</div>
                                        </div>
                                    </div>
                                    <div v-if="cloud_device_events != null">
                                        <div v-if="cloud_device_event_type == null">
                                            <TimelineDevice style="margin-top: -45px;" timelineHeight="490" :events="cloud_device_events.timeline" ref="CDeventsTimeline"></TimelineDevice>
                                        </div>
                                        <div v-if="cloud_device_event_type == 'list'">
                                            <div class="mt-1" style="">
                                                <div class="bg-black rounded">
                                                    <div class="mt-1" id="markers_notificators">
                                                        <div id="markerTargetsTable">   
                                                            <div class="tableFixHead" style="height: 440px;">
                                                                <table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5" title="Event Enumeration">
                                                                                <i class="fa-solid fa-lg fa-arrow-up-1-9"></i>
                                                                            </th>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5"  title="Event Type">
                                                                                <i class="fa-solid fa-lg fa-cube"></i>
                                                                            </th>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5 text-start" title="Device">
                                                                                <i class="fa-solid fa-lg fa-desktop"></i>
                                                                            </th>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5 text-start" title="Name">
                                                                                Name
                                                                            </th>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5 text-start" title="Description">
                                                                                Description
                                                                            </th>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5" title="Timestamp">
                                                                                <i class="fa-solid fa-lg fa-clock"></i>
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(_event, _evi) in cloud_device_events.data" v-bind:key="_evi+1"> <!-- Content Row -->
                                                                            <td class="text-center bg-transparent" style="border-bottom: solid 1px rgb(50,50,50); width: 5%;">
                                                                                <button class="btn bg-gradient fw-light fs-6 border-0 rounded text-center" :class="{'btn-alchemy-success': _event.severity == 'CLEAR', 'btn-alchemy-warning': _event.severity == 'MINOR', 'btn-alchemy-danger': _event.severity == 'MAJOR' }" :title="`Severity: ${_event.severity}`">
                                                                                    {{_evi+1}}
                                                                                </button>
                                                                            </td>
                                                                            <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50); width: 50px;">
                                                                                <button class="btn btn-alchemy-dark bg-gradient fw-light fs-6" :title="`Alert Type : ${_event.type}`" :class="{'btn-alchemy-success': _event.severity == 'CLEAR', 'btn-alchemy-warning': _event.severity == 'MINOR', 'btn-alchemy-danger': _event.severity == 'MAJOR' }">
                                                                                    <i class="fa-solid fa-lg" :class="{ 'fa-heart-pulse':  _event.type=='status',
                                                                                                                        'fa-microchip':  _event.type=='cpu',
                                                                                                                        'fa-memory':    _event.type=='memory',
                                                                                                                        'fa-link':       _event.type=='ping',
                                                                                                                        'fa-gear':      _event.type=='process',
                                                                                                                        'fa-clock':     _event.type=='process-timeout',
                                                                                                                        'fa-ethernet':  _event.type=='target-interface',
                                                                                                                        'fa-gears':     _event.type=='target-os-service',
                                                                                                                        'fa-beat-fade': _event.severity != 'CLEAR' }"></i>
                                                                    
                                                                                </button>
                                                                            </td>
                                                                            <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 20%;">
                                                                                <input class="fw-bold fs-6 border-0 rounded text-white text-start w-100" :value="_event.parent_name" style="cursor: default; background-color: transparent; opacity: 1;" disabled>
                                                                            </td>
                                                                            <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 25%;">
                                                                                <input class="fs-6 border-0 rounded text-white text-start w-100" :value="_event.name" style="cursor: default; background-color: transparent;" readonly>
                                                                            </td>
                                                                            <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30%;">
                                                                                <input class="fw-light fs-6 border-0 rounded text-white text-start w-100" :value="_event.description" style="cursor: default; background-color: transparent;" readonly>
                                                                            </td>
                                                                            <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 15%;">
                                                                                <input class="fw-light fs-6 border-0 rounded text-white text-center w-100" :value="_event.registration" style="cursor: default; background-color: transparent;" readonly>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- ACCESS POINT Detail Alerts -->
                            <div v-if="cloud_device_mode == 'alerts'">
                                <div class="input-group flex-nowrap mt-3">
                                    <!-- ACCESS POINT Detail Alerts -->
                                    <div class="input-group flex-nowrap me-2" style="width: 100%; pointer-events: none;">
                                        <button class="btn text-white bg-alchemy fs-4 me-1" style="width: 15%;" title="Total alerts">
                                            <i class="fa-solid fa-xl fa-bell text-warning"></i>
                                            {{cloud_device.alerts.length}}
                                        </button>
                                        <div class="btn bg-alchemy text-white text-start fw-light fs-3" style="width: 85%; letter-spacing: 4px;">Alerts</div>
                                    </div>
                                </div>
                                <div class="input-group flex-nowrap">
                                    <div class="me-2" style="width: 100%;">
                                        <div class="bg-alchemy-two fw-light fs-4 mt-1 w-100 p-1" style="height: 460px; overflow-y: scroll;">
                                            <div v-if="cloud_device.alerts.length == 0"  style="margin-top: 15%;">
                                                <i class="fa-solid fa-xl fs-1 fa-check fa-fade text-info"></i>
                                                <div class="text-white" style="letter-spacing: 3px;">No Alerts</div>
                                            </div>
                                            <div v-if="cloud_device.alerts.length > 0">
                                                <div class="input-group flex-nowrap bg-black mt-2" v-for="(alert, ai) in cloud_device.alerts" v-bind:key="ai+1">
                                                    <button class="btn fs-4 me-1 text-white">
                                                        {{ai+1}}
                                                    </button>
                                                    <button class="btn fs-5 me-1" style="width: 10%;" :title="alert.severity">
                                                        <i class="fa-solid fa-xl fa-triangle-exclamation" :class="{'text-danger': alert.level == 1, 'text-warning': alert.level == 2}"></i>
                                                    </button>
                                                    <select class="btn fs-5 me-1 text-start text-white" style="width: 80%;">
                                                        <option>Name | {{alert.name}}</option>
                                                        <option>Desc | {{alert.description}}</option>
                                                    </select>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- SWITCH Detail -->
                        <div v-if="cloud_dtype == 'switch'"></div>

                        <!-- FIREWALL Detail -->
                        <div v-if="cloud_dtype == 'firewall'">
                            <!-- FIREWALL Detail Header -->
                            <div class="input-group flex-nowrap">
                                <button class="btn btn-alchemy-dark fs-5 me-1" title="Cloud Device Name">
                                    <i class="fa-solid fa-xl fa-cloud text-primary"></i>
                                </button>
                                <input type="text" :value="cloud_device.name" title="Device Name" class="btn fw-light text-start fw-light bg-alchemy fs-5" style="letter-spacing: 0px; width: 90%;" readonly>
                                <button class="btn fs-5 rounded me-1" :class="{'bg-alchemy border-alchemy bg-gradient': cloud_device_mode == 'info', 'bg-alchemy bg-gradient': cloud_device_mode != 'info'}" style="width: 7%;" title="Device Info" @click="cloud_device_mode = 'info'">
                                    <i class="fa-solid fa-xl fa-info text-primary"></i>
                                </button>
                                <button class="btn bg-gradient fs-5 rounded me-1" :class="{'bg-alchemy border-alchemy bg-gradient': cloud_device_mode == 'health', 'bg-alchemy bg-gradient': cloud_device_mode != 'health'}" style="width: 7%;" title="Device Health" @click="cloud_device_mode = 'health'">
                                    <i class="fa-solid fa-xl fa-heart text-danger"></i>
                                </button>
                                <button class="btn bg-gradient fs-5 rounded me-1" :class="{'bg-alchemy border-alchemy bg-gradient': cloud_device_mode == 'graph', 'bg-alchemy bg-gradient': cloud_device_mode != 'graph'}" style="width: 7%;" title="Device History" @click="cloud_device_mode = 'graph'; cloud_history_mode='device'; cloud_device_graph_type=null;">
                                    <i class="fa-solid fa-xl fa-chart-line text-info"></i>
                                </button>
                                <button class="btn bg-gradient fs-5 rounded me-1" :class="{'bg-alchemy border-alchemy bg-gradient': cloud_device_mode == 'events', 'bg-alchemy bg-gradient': cloud_device_mode != 'events'}" style="width: 7%;" title="Device Alerts" @click="cloud_device_mode = 'events'; cloud_device_events=null;">
                                    <i class="fa-solid fa-xl fa-calendar-day text-secondary"></i>
                                </button>
                                <button class="btn bg-gradient fs-5 rounded" :class="{'bg-alchemy border-alchemy bg-gradient': cloud_device_mode == 'alerts', 'bg-alchemy bg-gradient': cloud_device_mode != 'alerts'}" style="width: 7%;" title="Device Alerts" @click="cloud_device_mode = 'alerts'">
                                    <i class="fa-solid fa-xl fa-bell text-warning"></i>
                                </button>
                                <div class="" style="width: 40%;"></div>
                                <button class="btn bg-alchemy bg-gradient rounded me-1" @click="setCloudDevice('past')" title="Previous device">
                                    <i class="fa-solid fa-xl fa-arrow-left text-primary"></i>
                                </button>
                                <button class="btn bg-gradient bg-alchemy fs-5 rounded me-1" style="width: 15%;" title="Total Devices (Includes filtering)">
                                    {{ filtered_cloud_markers.indexOf(cloud_device) + 1 }}  / {{ filtered_cloud_markers.length }}
                                </button>
                                <button class="btn bg-alchemy bg-gradient rounded me-1" @click="setCloudDevice('next')" title="Next device">
                                    <i class="fa-solid fa-xl fa-arrow-right text-primary"></i>
                                </button>
                                <button class="btn bg-alchemy bg-gradient fs-4 rounded" @click="cloud_mode='table'; cloud_device: null; cloud_device_mode='info'; cloud_device_history = null; cloud_device_radio_graph = null;">
                                    <i class="fa-solid fa-xl fa-close text-danger"></i>
                                </button>
                            </div>
                            <!-- FIREWALL Detail Info -->
                            <div v-if="cloud_device_mode == 'info'" class="mt-2">
                                <div class="input-group flex-nowrap mt-3">
                                    <button class="btn bg-alchemy fs-4 me-1" style="width: 13%;">
                                        <i class="fa-solid fa-xl fa-info text-primary"></i>
                                    </button>
                                    <div class="btn bg-alchemy text-white text-start fw-light fs-3" style="width: 91%; letter-spacing: 4px;">Device Information</div>
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <button class="btn bg-alchemy fs-5 me-1" style="width: 14%;" title="Role">
                                        <img id="roleimg" :src="getImage(cloud_device.role)" :title="String(cloud_device.role).toUpperCase()" :alt="cloud_device.role"  class="img-fluid rounded border-0">
                                        <div>{{String(cloud_device.role).toUpperCase()}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-5 me-1" style="width: 30%; letter-spacing: 0px;" title="Device Name">
                                        <i class="fa-solid fa-xl fa-cloud text-primary mb-4"></i>
                                        <div>{{cloud_device.name}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4 me-1" style="width: 30%; letter-spacing: 3px;" title="Device Alias">
                                        <i class="fa-solid fa-xl fa-id-badge text-info mb-4"></i>
                                        <div>{{cloud_device.alias}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4" style="width: 30%; letter-spacing: 3px;" title="Cloud ID">
                                        <i class="fa-solid fa-xl fa-cloud text-primary me-1"></i>
                                        <i class="fa-solid fa-xl fa-i"></i>
                                        <i class="fa-solid fa-xl fa-d mb-4"></i>
                                        <div>{{cloud_device.uid_cloud}}</div>
                                    </button>
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <button class="btn bg-alchemy fs-5 me-1" style="width: 14%;" title="Operating System">
                                        <img :src="getImage(oss[cloud_device.os])" :title="String(oss[cloud_device.os]).toUpperCase()" class="img-fluid rounded border-0">
                                        <div>{{String(cloud_device.os).toUpperCase()}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4 me-1" style="width: 32%; letter-spacing: 3px;" title="MAC Address">
                                        <i class="fa-solid fa-xl fa-m text-secondary"></i>
                                        <i class="fa-solid fa-xl fa-a text-secondary"></i>
                                        <i class="fa-solid fa-xl fa-c text-secondary mb-4"></i>
                                        <div>{{cloud_device.mac}}</div>
                                    </button>
                                    <button class="btn fw-light fs-4 me-1" :class="{'bg-alchemy': cloud_device.active == 1, 'bg-alchemy-danger': cloud_device.active != 1}" style="width: 30%; letter-spacing: 3px;" title="Monitoring permission status">
                                        <i class="fa-solid fa-xl fa-power-off mb-4" :class="{'text-success': cloud_device.active == 1, 'text-dark': cloud_device.active != 1}"></i>
                                        <div>{{cloud_device.active == 1 ? 'Monitoring: ON':'Monitoring: OFF'}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4" style="width: 30%; letter-spacing: 3px;" title="Last Update">
                                        <i class="fa-solid fa-xl fa-calendar text-info mb-4"></i>
                                        <div>{{cloud_device.last_update}}</div>
                                    </button>
                                </div>
                            </div>
                            <!-- FIREWALL Detail Health -->
                            <div v-if="cloud_device_mode == 'health'">
                                <div class="input-group flex-nowrap mt-3">
                                    <button class="btn bg-alchemy fs-4 me-1" style="width: 13%;">
                                        <i class="fa-solid fa-xl fa-heart text-danger"></i>
                                    </button>
                                    <div class="btn bg-alchemy text-white text-start fw-light fs-3" style="width: 91%; letter-spacing: 4px;">Device Health</div>
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <button class="btn fw-light fs-4 me-1" :class="{'bg-alchemy': cloud_device.status == 'up', 'bg-alchemy-danger': cloud_device.status != 'up'}"  style="width: 50%; letter-spacing: 3px;">
                                        <i class="fa-solid fa-xl fa-heart mb-4" :class="{'text-info': cloud_device.status == 'up', 'text-black fa-beat-fade': cloud_device.status != 'up'}"></i>
                                        <div>{{cloud_device.status == 'up' ? 'Status: UP':'Status: '+String(cloud_device.status).toUpperCase()}}</div>
                                    </button>
                                    <button class="btn fw-light bg-alchemy fs-4 me-1" style="width: 50%; letter-spacing: 3px;">
                                        <i class="fa-solid fa-xl fa-signal mb-4" :class="{'text-primary': cloud_device.connectivity == 1, 'text-danger fa-fade': cloud_device.connectivity != 1}"></i>
                                        <div>{{cloud_device.connectivity == 1 ? 'Connectivity: YES':'Connectivity: NO'}}</div>
                                    </button>
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <div class="btn bg-alchemy-two fw-light fs-4" style="width: 100%; height: 350px; overflow-y: scroll; letter-spacing: 3px; cursor: default;">
                                        <i class="fa-solid fa-xl fa-leaf text-success"></i>
                                        <div>Vendor Specific</div>
                                        <div v-for="(vsv, vsk, vsi) in cloud_device.vendor_specific" v-bind:key="vsi+1">
                                            <div class="input-group flex-nowrap bg-black border-bottom-alchemy rounded mt-2">
                                                <button class="btn">
                                                    <i class="fa-solid fa-xl fa-box text-primary"></i>
                                                </button>
                                                <button class="btn fs-5 text-white text-start" style="width: 90%;">
                                                    {{capitalize(vsk.replace('_',' '))}}
                                                </button>
                                                <button class="btn fs-5 text-white">
                                                    {{vsv}}
                                                </button>
                                                <button class="btn fs-5 text-white">
                                                    {{ Object.keys(vendor_sp).includes(vsk) ? vendor_sp[vsk] : '-' }}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- FIREWALL Detail Graph -->
                            <div v-if="cloud_device_mode == 'graph'">
                                <div class="input-group flex-nowrap mt-3">
                                    <button class="btn bg-alchemy fs-4 me-1" style="width: 13%;">
                                        <i class="fa-solid fa-xl fa-chart-line text-info"></i>
                                    </button>
                                    <select class="btn bg-alchemy text-white text-start fw-light rounded fs-5" style="width: 28%; letter-spacing: 4px;" v-model="cloud_history_mode" @change="cloud_device_graph_type = null;">
                                        <option :value="'device'">Device History</option>
                                    </select>
                                     <!-- FIREWALL Interval Start -->
                                    <button class="btn bg-alchemy fs-5 rounded ms-3" style="cursor: default; border-right: solid 3px black; width: 5%; pointer-events: none;" :disabled="getting_cloud_history">
                                        <i class="fa-solid fa-xl fa-hourglass-start text-success"></i>
                                    </button>
                                    <input type="date" class="btn bg-alchemy text-white fs-6 me-1" style="width: 13%; color-scheme: dark;" v-model="cl_start.date" :disabled="getting_cloud_history">
                                    <input type="time" class="btn bg-alchemy text-white fs-6 rounded" style="width: 12%; color-scheme: dark;" v-model="cl_start.time" :disabled="getting_cloud_history">
                                    <!-- FIREWALL Interval End -->
                                    <button class="btn bg-alchemy fs-5 rounded ms-3" style="border-right: solid 3px black; width: 5%;" @click="setNow" :disabled="getting_cloud_history">
                                        <i class="fa-solid fa-xl fa-hourglass-end text-danger"></i>
                                    </button>
                                    <input type="date" class="btn bg-alchemy text-white fs-6" style="width: 13%; color-scheme: dark;" v-model="cl_end.date" :disabled="getting_cloud_history">
                                    <input type="time" class="btn bg-alchemy text-white fs-6 rounded" style="width: 12%; color-scheme: dark;" v-model="cl_end.time" :disabled="getting_cloud_history">
                                    <!-- FIREWALL Interval Search -->
                                    <button class="btn bg-alchemy fs-4 rounded ms-3" style="width: 5%;" @click="getCloudDeviceHistory(true)">
                                        <i class="fa-solid fa-xl fa-search text-info"></i>
                                    </button>
                                </div>
                                <div class="bg-alchemy-two fw-light fs-4 mt-1 w-100 p-1" style="height: 460px; overflow-y: hidden;">
                                    <div v-if="cloud_device_history == null">
                                        <div class="" style="margin-top: 15%;">
                                            <i class="fa-solid fa-xl fs-1 fa-chart-line fa-fade text-info" :class="{'fa-beat-fade': getting_cloud_history}"></i>
                                            <div v-if="!getting_cloud_history" class="text-white" style="letter-spacing: 3px;">...</div>
                                            <div v-if="getting_cloud_history" class="text-white" style="letter-spacing: 3px;">Searching history, please wait...</div>
                                        </div>
                                    </div>
                                    <div v-if="cloud_device_history != null && cloud_history_mode == 'device'">
                                        <div class="input-group flex-nowrap">
                                            <button class="btn bg-black text-start text-info fs-5 border-bottom-alchemy rounded me-2" @click="getCloudDeviceReport();" title="Get device report." :disabled="getting_cd_report">
                                                <i class="fa-solid fa-xl fa-file-excel text-info" :class="{'fa-beat-fade': getting_cd_report}"></i>
                                            </button>
                                            <select  class="btn bg-black text-start text-info fs-5 border-bottom-alchemy rounded" v-model="cloud_device_graph_type">
                                                <option :value="null">Status</option>
                                                <option :value="'scores'">Performance Score</option>
                                            </select>
                                        </div>
                                        <div v-if="cloud_device_graph_type==null">
                                            <StatusGraph chart-id="cloud_ap_status_graph" :chart-data="cloud_device_history.device.status"></StatusGraph>
                                        </div>
                                        <div v-if="cloud_device_graph_type=='scores'">
                                            <CloudFWPS chart-id="cloud_fw_pfscore_graph" :chart-data="cloud_device_history.device.perscores"></CloudFWPS>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- FIREWALL Detail Events -->
                            <div v-if="cloud_device_mode == 'events'">
                                <div class="input-group flex-nowrap mt-3">
                                    <button class="btn bg-alchemy fs-4 me-1" style="width: 13%;">
                                        <i class="fa-solid fa-xl fa-calendar-day text-secondary"></i>
                                    </button>
                                    <input type="text" class="btn bg-alchemy text-white text-start fw-light rounded fs-3" style="width: 14%; letter-spacing: 4px; pointer-events: none;" value="Events" readonly>
                                    <select class="btn bg-alchemy text-white text-start text-secondary fs-5 rounded" v-model="cloud_device_event_type">
                                        <option :value="null">Timeline</option>
                                        <option value="list">List</option>
                                    </select>
                                    <!-- ACCESS POINT Interval Start -->
                                    <button class="btn bg-alchemy fs-5 rounded ms-3" style="cursor: default; border-right: solid 3px black; width: 5%;" :disabled="getting_cloud_history">
                                        <i class="fa-solid fa-xl fa-hourglass-start text-success"></i>
                                    </button>
                                    <input type="date" class="btn bg-alchemy text-white fs-6 me-1" style="width: 13%; color-scheme: dark;" v-model="cl_start.date" :disabled="getting_cloud_history">
                                    <input type="time" class="btn bg-alchemy text-white fs-6 rounded" style="width: 12%; color-scheme: dark;" v-model="cl_start.time" :disabled="getting_cloud_history">
                                    <!-- ACCESS POINT Interval End -->
                                    <button class="btn bg-alchemy fs-5 rounded ms-3" style="border-right: solid 3px black; width: 5%;" @click="setNow" :disabled="getting_cloud_history">
                                        <i class="fa-solid fa-xl fa-hourglass-end text-danger"></i>
                                    </button>
                                    <input type="date" class="btn bg-alchemy text-white fs-6" style="width: 13%; color-scheme: dark;" v-model="cl_end.date" :disabled="getting_cloud_history">
                                    <input type="time" class="btn bg-alchemy text-white fs-6 rounded" style="width: 12%; color-scheme: dark;" v-model="cl_end.time" :disabled="getting_cloud_history">
                                    <!-- ACCESS POINT Interval Search -->
                                    <button class="btn bg-alchemy fs-4 rounded ms-3" style="width: 5%;" @click="getCloudDeviceEvents(true)">
                                        <i class="fa-solid fa-xl fa-search text-info"></i>
                                    </button>
                                </div>
                                <div class="bg-alchemy-two fw-light fs-4 mt-1 w-100 p-2" style="height: 460px; overflow-y: hidden;">
                                    <div v-if="cloud_device_events == null">
                                        <div class="" style="margin-top: 15%;">
                                            <i class="fa-solid fa-xl fs-1 fa-calendar fa-fade text-secondary" :class="{'fa-beat-fade': getting_cloud_events}"></i>
                                            <div v-if="!getting_cloud_events" class="text-white" style="letter-spacing: 3px;">...</div>
                                            <div v-if="getting_cloud_events" class="text-white" style="letter-spacing: 3px;">Searching events, please wait...</div>
                                        </div>
                                    </div>
                                    <div v-if="cloud_device_events != null">
                                        <div v-if="cloud_device_event_type == null">
                                            <TimelineDevice style="margin-top: -45px;" timelineHeight="490" :events="cloud_device_events.timeline" ref="CDeventsTimeline"></TimelineDevice>
                                        </div>
                                        <div v-if="cloud_device_event_type == 'list'">
                                            <div class="mt-1" style="">
                                                <div class="bg-black rounded">
                                                    <div class="mt-1" id="markers_notificators">
                                                        <div id="markerTargetsTable">   
                                                            <div class="tableFixHead" style="height: 440px;">
                                                                <table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5" title="Event Enumeration">
                                                                                <i class="fa-solid fa-lg fa-arrow-up-1-9"></i>
                                                                            </th>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5"  title="Event Type">
                                                                                <i class="fa-solid fa-lg fa-cube"></i>
                                                                            </th>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5 text-start" title="Device">
                                                                                <i class="fa-solid fa-lg fa-desktop"></i>
                                                                            </th>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5 text-start" title="Name">
                                                                                Name
                                                                            </th>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5 text-start" title="Description">
                                                                                Description
                                                                            </th>
                                                                            <th class="fw-light bg-alchemy border-bottom-alchemy text-white fs-5" title="Timestamp">
                                                                                <i class="fa-solid fa-lg fa-clock"></i>
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(_event, _evi) in cloud_device_events.data" v-bind:key="_evi+1"> <!-- Content Row -->
                                                                            <td class="text-center bg-transparent" style="border-bottom: solid 1px rgb(50,50,50); width: 5%;">
                                                                                <button class="btn bg-gradient fw-light fs-6 border-0 rounded text-center" :class="{'btn-alchemy-success': _event.severity == 'CLEAR', 'btn-alchemy-warning': _event.severity == 'MINOR', 'btn-alchemy-danger': _event.severity == 'MAJOR' }" :title="`Severity: ${_event.severity}`">
                                                                                    {{_evi+1}}
                                                                                </button>
                                                                            </td>
                                                                            <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50); width: 50px;">
                                                                                <button class="btn btn-alchemy-dark bg-gradient fw-light fs-6" :title="`Alert Type : ${_event.type}`" :class="{'btn-alchemy-success': _event.severity == 'CLEAR', 'btn-alchemy-warning': _event.severity == 'MINOR', 'btn-alchemy-danger': _event.severity == 'MAJOR' }">
                                                                                    <i class="fa-solid fa-lg" :class="{ 'fa-heart-pulse':  _event.type=='status',
                                                                                                                        'fa-microchip':  _event.type=='cpu',
                                                                                                                        'fa-memory':    _event.type=='memory',
                                                                                                                        'fa-link':       _event.type=='ping',
                                                                                                                        'fa-gear':      _event.type=='process',
                                                                                                                        'fa-clock':     _event.type=='process-timeout',
                                                                                                                        'fa-ethernet':  _event.type=='target-interface',
                                                                                                                        'fa-gears':     _event.type=='target-os-service',
                                                                                                                        'fa-beat-fade': _event.severity != 'CLEAR' }"></i>
                                                                    
                                                                                </button>
                                                                            </td>
                                                                            <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 20%;">
                                                                                <input class="fw-bold fs-6 border-0 rounded text-white text-start w-100" :value="_event.parent_name" style="cursor: default; background-color: transparent; opacity: 1;" disabled>
                                                                            </td>
                                                                            <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 25%;">
                                                                                <input class="fs-6 border-0 rounded text-white text-start w-100" :value="_event.name" style="cursor: default; background-color: transparent;" readonly>
                                                                            </td>
                                                                            <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30%;">
                                                                                <input class="fw-light fs-6 border-0 rounded text-white text-start w-100" :value="_event.description" style="cursor: default; background-color: transparent;" readonly>
                                                                            </td>
                                                                            <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 15%;">
                                                                                <input class="fw-light fs-6 border-0 rounded text-white text-center w-100" :value="_event.registration" style="cursor: default; background-color: transparent;" readonly>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- FIREWALL Detail Alerts -->
                            <div v-if="cloud_device_mode == 'alerts'">
                                <div class="input-group flex-nowrap mt-3">
                                    <!-- FIREWALL Detail Alerts -->
                                    <div class="input-group flex-nowrap me-2" style="width: 100%;">
                                        <button class="btn text-white bg-alchemy fs-4 me-1" style="width: 15%;" title="Total alerts">
                                            <i class="fa-solid fa-xl fa-bell text-warning"></i>
                                            {{cloud_device.alerts.length}}
                                        </button>
                                        <div class="btn bg-alchemy text-white text-start fw-light fs-3" style="width: 85%; letter-spacing: 4px;">Alerts</div>
                                    </div>
                                </div>
                                <div class="input-group flex-nowrap">
                                    <div class="me-2" style="width: 100%;">
                                        <div class="bg-alchemy-two fw-light fs-4 mt-1 w-100 p-1" style="height: 460px; overflow-y: scroll;">
                                            <div v-if="cloud_device.alerts.length == 0"  style="margin-top: 15%;">
                                                <i class="fa-solid fa-xl fs-1 fa-check fa-fade text-info"></i>
                                                <div class="text-white" style="letter-spacing: 3px;">No Alerts</div>
                                            </div>
                                            <div v-if="cloud_device.alerts.length > 0">
                                                <div class="input-group flex-nowrap bg-black mt-2" v-for="(alert, ai) in cloud_device.alerts" v-bind:key="ai+1">
                                                    <button class="btn fs-4 me-1 text-white">
                                                        {{ai+1}}
                                                    </button>
                                                    <button class="btn fs-5 me-1" style="width: 10%;" :title="alert.severity">
                                                        <i class="fa-solid fa-xl fa-triangle-exclamation" :class="{'text-danger': alert.level == 1, 'text-warning': alert.level == 2}"></i>
                                                    </button>
                                                    <select class="btn fs-5 me-1 text-start text-white" style="width: 80%;">
                                                        <option>Name | {{alert.name}}</option>
                                                        <option>Desc | {{alert.description}}</option>
                                                    </select>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- STANDARD DEVICES Detail Modal -->
    <div class="modal fade" id="deviceDetail" tabindex="-1">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content bg-black">
                <!-- Header -->
                <div class="modal-header border-0 bg-alchemy-two bg-gradient">
                    <div class="input-group flex-nowrap">
                        <button v-if="!gettingMarkers" class="btn text-white text-start fs-1" style="width: 97%; cursor: default; letter-spacing: 5px; opacity: 1;" disabled>{{selected_marker.name}} - {{selected_marker.ip}}</button>
                        <button v-if="gettingMarkers" class="btn text-white text-start fs-1 fa-fade" style="width: 97%; cursor: default; letter-spacing: 5px;">Updating data please wait...</button>
                        <button class="btn btn-alchemy-dark rounded" title="Close device detail." data-bs-dismiss="modal" style="width: 5%" @click="clearMarkerView">
                            <i class="fa-solid fa-2xl fa-close"></i>
                        </button>
                    </div>
                </div>
                <!-- Body -->
                <div class="modal-body bg-black" style="overflow: hidden;">
                    <div class="row">
                        <div class="col-md-1">
                            <div class="p-2 rounded bg-alchemy-two bg-gradient" style="height: 650px;" :class="{'disabled-div': gettingMarkers}">
                                <button class="btn fs-3 w-100" @click="detail_mode='info'" :class="{'btn-alchemy-success': detail_mode=='info', 'btn-alchemy-dark': detail_mode!='info'}">
                                    <i class="fa-solid fa-xl fa-info"></i>
                                </button>
                                <button class="btn fs-3 w-100 mt-2" @click="detail_mode='health'" :class="{'btn-alchemy-success': detail_mode=='health', 'btn-alchemy-dark': detail_mode!='health'}">
                                    <i class="fa-solid fa-xl fa-heart"></i>
                                </button>
                                <button class="btn fs-3 w-100 mt-2" @click="detail_mode='targets'; target_view='list'; clearTargets();" :class="{'btn-alchemy-success': detail_mode=='targets', 'btn-alchemy-dark': detail_mode!='targets'}" :disabled="selected_marker.os == 'superficial'">
                                    <i class="fa-solid fa-xl fa-bullseye"></i>
                                </button>
                                <button class="btn fs-3 w-100 mt-2" @click="detail_mode='alerts'" :class="{'btn-alchemy-success': detail_mode=='alerts', 'btn-alchemy-dark': detail_mode!='alerts'}">
                                    <i class="fa-solid fa-xl fa-bell"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-md-11">
                            <div v-if="selected_marker.os != null" class="bg-alchemy-two rounded p-2 bg-gradient" style="height: 650px;">
                                <!-- Info -->
                                <div v-if="detail_mode=='info'">
                                    <div class="input-group flex-nowrap">
                                        <input type="text" class="btn text-white fw-light fs-2 text-start w-100" style="letter-spacing: 5px; cursor: default; opacity: 1.0;" disabled value="Device Information" readonly>
                                    </div>
                                    <div class="input-group flex-nowrap mt-2">
                                        <button class="btn btn-alchemy-dark fs-3 me-1" style="width: 10%;">
                                            <i class="fa-solid fa-xl fa-server"></i>
                                        </button>
                                        <input type="text" class="btn btn-alchemy-dark fw-light fs-2 text-start rounded me-3" style="letter-spacing: 5px; cursor: default; width: 40%;" :value="selected_marker.name" readonly>
                                        <button class="btn btn-alchemy-dark fs-3 me-1 rounded" style="width: 10%;">
                                            <i class="fa-solid fa-xl fa-id-badge"></i>
                                        </button>
                                        <input type="text" class="btn btn-alchemy-dark  fw-light fs-2 text-start" style="letter-spacing: 5px; cursor: default; width: 40%;" :value="selected_marker.alias" readonly>
                                    </div>
                                    <div class="input-group flex-nowrap mt-3">
                                        <button class="btn btn-alchemy-dark fs-3 me-1" style="width: 10%;">
                                            <i class="fa-solid fa-xl fa-network-wired"></i>
                                        </button>
                                        <input type="text" class="btn btn-alchemy-dark fw-light fs-2 text-start rounded me-3" style="letter-spacing: 5px; cursor: default; width: 40%;" :value="selected_marker.ip" readonly>
                                        <button class="btn btn-alchemy-dark fs-3 me-1 rounded" style="width: 10%;">
                                            <i class="fa-solid fa-xl fa-clock"></i>
                                        </button>
                                        <input type="text" class="btn btn-alchemy-dark  fw-light fs-2 text-start" style="letter-spacing: 5px; cursor: default; width: 40%;" :value="selected_marker.last_update" readonly>
                                    </div>
                                    <div class="input-group flex-nowrap mt-4">
                                        <div class="w-50 fs-3 text-white bg-alchemy me-3 rounded" style="letter-spacing: 5px;">
                                            {{ capitalize(selected_marker.role) }}
                                        </div>
                                        <div class="w-50 fs-3 text-white bg-alchemy rounded" style="letter-spacing: 5px;">
                                            {{ (oss[selected_marker.os]).toUpperCase() }}
                                        </div>
                                    </div>
                                    <div class="input-group flex-nowrap mt-1">
                                        <div class="w-50 me-3">
                                            <img id="roleimg" :src="getImage(selected_marker.role)" :title="capitalize(selected_marker.role)" :alt="selected_marker.role" width="320" class="img-fluid rounded border-0 mt-2">
                                        </div>
                                        <div class="w-50">
                                            <img :src="getImage(oss[selected_marker.os])" :title="capitalize(oss[selected_marker.os])" width="320" class="img-fluid rounded border-0 mt-2">
                                        </div>
                                    </div>
                                </div>
                                <!-- Health -->
                                <div v-if="detail_mode=='health'">
                                    <div class="input-group flex-nowrap">
                                        <input type="text" class="btn text-white fw-light fs-2 text-start w-100" disabled style="letter-spacing: 5px; cursor: default; opacity: 1.0;" value="Health" readonly>
                                    </div>
                                    <!-- Ping -->
                                    <div class="input-group flex-nowrap mt-1">
                                        <button class="btn bg-alchemy-dark fs-3 text-start me-1" style="width: 20%;">
                                            <i class="fa-solid fa-rss me-3"></i>
                                            Ping
                                        </button>
                                        <input type="text" class="btn fs-5 text-start me-1" style="width: 20%; opacity: 1;" :class="{'bg-alchemy-dark': selected_marker.ping.success > selected_marker.ping.tolerance, 'bg-alchemy-danger fa-fade': selected_marker.ping.success <= selected_marker.ping.tolerance }" :value="'Success: ' + selected_marker.ping.success + '%'" :title="`Ping Success Rate: ${selected_marker.ping.success}%\nTolerance: ${selected_marker.ping.tolerance}%`" disabled>
                                        <input type="text" class="btn bg-alchemy-dark fs-5 text-start me-1" style="width: 20%; opacity: 1;" :value="'RTT: ' + selected_marker.ping.rtt + ' ms'" :title="`RTT: ${selected_marker.ping.rtt} ms\nTolerance: ${selected_marker.ping.rtt} ms`" disabled>
                                        <input type="text" class="btn fs-5 text-start me-1" style="width: 28%; opacity: 1;" :class="{'bg-alchemy-dark': selected_marker.ping.latency < selected_marker.ping.latency_tolerance, 'bg-alchemy-danger fa-fade': selected_marker.ping.latency >= selected_marker.ping.latency_tolerance }" :value="'Latency: ' + selected_marker.ping.latency + ' ms'" :title="`Ping Latency: ${selected_marker.ping.latency} ms\nTolerance: ${selected_marker.ping.latency_tolerance} ms`" disabled>
                                        <input type="text" class="btn fs-5 text-start me-1" style="width: 28%; opacity: 1;" :class="{'bg-alchemy-dark': selected_marker.ping.jitter < selected_marker.ping.jitter_tolerance, 'bg-alchemy-danger fa-fade': selected_marker.ping.jitter >= selected_marker.ping.jitter_tolerance }" :value="'Jitter: ' + selected_marker.ping.jitter + ' ms'" :title="`Ping Jitter: ${selected_marker.ping.jitter} ms\nTolerance: ${selected_marker.ping.jitter_tolerance} ms`" disabled>
                                        <div v-if="false" class="progress rounded w-100" style="height: 60px;">
                                            <div class="progress-bar" :class="{ 'bg-alchemy-success': selected_marker.ping.success > selected_marker.ping.tolerance, 'bg-alchemy-danger': selected_marker.ping.success <= selected_marker.ping.tolerance }" role="progressbar" :style="`width: ${selected_marker.ping.success}%; font-size: 25px;`" aria-valuemin="0" aria-valuemax="100"> Success: {{selected_marker.ping.success}}% </div>
                                            <div class="progress-bar bg-black" role="progressbar" :style="`width: ${selected_marker.ping.loss}%; font-size: 25px;`"  aria-valuemin="0" aria-valuemax="100">  Loss: {{selected_marker.ping.loss}}% </div>
                                        </div>
                                        <input v-if="selected_marker.os == 'superficial'" type="text" class="btn fs-5 text-start" style="width: 28%; opacity: 1;" :value="`Accumulator: ${selected_marker.ping_alarm_counter} / ${selected_marker.ping_alarm_limit}`" :class="{'bg-alchemy-dark': selected_marker.ping_alarm_counter < selected_marker.ping_alarm_limit, 'bg-alchemy-danger fa-fade':selected_marker.ping_alarm_counter >= selected_marker.ping_alarm_limit}">
                                    </div>
                                    <!-- CPU -->
                                    <div class="input-group flex-nowrap mt-2" :class="{'disabled-div': selected_marker.os == 'superficial'}">
                                        <button class="btn bg-alchemy-dark fs-3 text-start me-1" style="width: 20%;">
                                            <i class="fa-solid fa-microchip me-3"></i>
                                            CPU
                                        </button>
                                        <div v-if="selected_marker.os != 'superficial'" class="progress rounded w-100" style="height: 60px;">
                                            <div class="progress-bar" :class="{ 'bg-alchemy-success': selected_marker.cpu.value < selected_marker.cpu.tolerance, 'bg-alchemy-danger': selected_marker.cpu.value >= selected_marker.cpu.tolerance }" role="progressbar" :style="`width: ${selected_marker.cpu.value}%; font-size: 25px;`" title="Used CPU." aria-valuemin="0" aria-valuemax="100"> {{selected_marker.cpu.value}}% </div>
                                            <div class="progress-bar bg-black" role="progressbar" :style="`width: ${ 100 - selected_marker.cpu.value }%; font-size: 25px;`" title="Free CPU."  aria-valuemin="0" aria-valuemax="100"> {{100 - selected_marker.cpu.value}}%  </div>
                                        </div>
                                        <div v-if="selected_marker.os == 'superficial'" class="progress rounded w-100" style="height: 60px;">
                                            <div class="progress-bar bg-black" role="progressbar" :style="`width: 100%; font-size: 25px;`" title="CPU monitoring unavailable for this OS."  aria-valuemin="0" aria-valuemax="100">
                                                CPU monitoring unavailable for this OS.
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Memory -->
                                    <div class="input-group flex-nowrap mt-2" :class="{'disabled-div': selected_marker.os == 'superficial'}">
                                        <button class="btn bg-alchemy-dark fs-3 text-start me-1" style="width: 20%;">
                                            <i class="fa-solid fa-memory me-3"></i>
                                            Memory
                                        </button>
                                        <div v-if="selected_marker.os != 'superficial'" class="progress rounded w-100" style="height: 60px;">
                                            <div class="progress-bar" :class="{ 'bg-alchemy-success': selected_marker.memory.value < selected_marker.memory.tolerance, 'bg-alchemy-danger': selected_marker.memory.value >= selected_marker.memory.tolerance }" role="progressbar" :style="`width: ${selected_marker.memory.value}%; font-size: 25px;`" title="Used Memory." aria-valuemin="0" aria-valuemax="100"> {{selected_marker.memory.value}}% </div>
                                            <div class="progress-bar bg-black" role="progressbar" :style="`width: ${ 100 - selected_marker.memory.value }%; font-size: 25px;`" title="Free Memory."  aria-valuemin="0" aria-valuemax="100"> {{100 - selected_marker.memory.value}}%  </div>
                                        </div>
                                        <div v-if="selected_marker.os == 'superficial'" class="progress rounded w-100" style="height: 60px;">
                                            <div class="progress-bar bg-black" role="progressbar" :style="`width: 100%; font-size: 25px;`" title="Memory monitoring unavailable for this OS."  aria-valuemin="0" aria-valuemax="100">
                                                Memory monitoring unavailable for this OS.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="input-group flex-nowrap mt-2" style="height: 370px;">
                                        <div class="bg-alchemy-two me-1 p-1 rounded" style="width: 20%; height: 100%;">
                                            <p class="fs-2 text-white fw-light">Interval</p>
                                            <div class="input-group flex-nowrap p-1">
                                                <button class="btn btn-alchemy-dark bg-gradient w-25 fs-4 rounded" style="cursor: default; border-right: solid 3px black;" :disabled="gettingHistory">
                                                    <i class="fa-solid fa-xl fa-hourglass-start"></i>
                                                </button>
                                                <div class="w-75">
                                                    <input type="date" class="btn btn-alchemy-dark bg-gradient w-100 fs-5" value="2023-03-15" v-model="hstart.date" :disabled="gettingHistory">
                                                    <input type="time" class="btn btn-alchemy-dark bg-gradient w-100 fs-5 mt-1" value="00:00" v-model="hstart.time" :disabled="gettingHistory">
                                                </div>
                                            </div>
                                            <div class="input-group flex-nowrap p-1 mt-1">
                                                <button class="btn btn-alchemy-dark bg-gradient w-25 fs-4 rounded" style="cursor: default; border-right: solid 3px black;" @click="setNow" :disabled="gettingHistory">
                                                    <i class="fa-solid fa-xl fa-hourglass-end"></i>
                                                </button>
                                                <div class="w-75">
                                                    <input type="date" class="btn btn-alchemy-dark bg-gradient w-100 fs-5" value="2023-03-15" v-model="hend.date" :disabled="gettingHistory">
                                                    <input type="time" class="btn btn-alchemy-dark bg-gradient w-100 fs-5 mt-1" value="00:00" v-model="hend.time" :disabled="gettingHistory">
                                                </div>
                                            </div>
                                            <div class="input-group flex-nowrap mt-1">
                                                <button class="btn btn-alchemy-dark bg-gradient fs-5 rounded me-1" @click="getHistoryReport('device_history')" :disabled="downloading">
                                                    <i class="fa-solid fa-xl fa-file-arrow-down" :class="{'fa-beat-fade': downloading}"></i>
                                                </button>
                                                <button class="btn btn-alchemy-dark bg-gradient w-50 fs-5 me-1" @click="toggleHealthGraph" :disabled="gettingHistory">
                                                    <i class="fa-solid fa-xl" :class="{'fa-heart': health_gm=='qos', 'fa-clock': health_gm=='health', 'fa-beat-fade': gettingHistory}"></i>
                                                </button>
                                                <button class="btn btn-alchemy-dark bg-gradient w-50 fs-5" @click="getHistoryGraphs(true);" :disabled="gettingHistory">
                                                    <i class="fa-solid fa-xl fa-arrow-right" :class="{'fa-beat-fade': gettingHistory}"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="bg-alchemy-two rounded" style="width: 80%; height: 100%;">
                                            <div>
                                                <div v-if="!gettingHistory && history" class="p-2" style="height: 360px; display: flex;">
                                                    <div v-if="health_gm=='health'">
                                                        <HealthGraph chart-id="health_graph" :chart-data="health_data"></HealthGraph>
                                                    </div>
                                                    <div v-if="health_gm=='qos'">
                                                        <QosGraph chart-id="qos_graph" :chart-data="qos_data"></QosGraph>
                                                    </div>
                                                </div>
                                                <div v-if="gettingHistory">
                                                    <div class="text-white fw-light fs-2" style="margin-top: 14%; margin-left: 0%;">
                                                        <i class="fa-solid fa-xl fa-heart fa-beat-fade" style="color: Red;"></i>
                                                        <p class="text-white fw-light">Retrieving health & QoS data, please wait.</p>
                                                    </div>
                                                </div>
                                                <div v-if="!gettingHistory && !history">
                                                    <div class="text-white fw-light fs-2" style="margin-top: 14%; margin-left: 0%;">
                                                        <i class="fa-solid fa-xl fa-heart" style="color: Red; opacity: 0.2;"></i>
                                                        <p class="text-white fw-light">Set time and date and generate graphs.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <!-- Targets -->
                                <div v-if="detail_mode=='targets'">
                                    <div class="input-group flex-nowrap">
                                        <button class="btn bg-alchemy text-white fs-2 ms-1 rounded" style="width: 10%;" @click="getAvailableTargets(selected_marker)" title="Click here to refresh the available targets." :disabled="target_mode!='interfaces_services'">
                                            <i class="fa-solid fa-circle-arrow-down" :class="{'fa-fade': gettingAvTargets || addingTarget}"></i>
                                        </button>
                                        <input type="text" class="btn text-white fw-light fs-2 text-start w-100" style="letter-spacing: 5px; cursor: default; width: 20%; pointer-events:none;" :value="`Targets - ${target_mode.replace('_',' & ')}`" readonly>
                                        <button class="btn text-white fs-5 me-1 rounded" style="width: 10%;" @click="target_mode='interfaces_services'; selected_target = selected_target_default; target_data_mode='alias'; resetObject(interface_target_data, null); newTargetAlias=null;" :class="{'bg-alchemy bg-gradient': target_mode!='interfaces_services', 'btn-alchemy': target_mode=='interfaces_services' }">
                                            <i class="fa-solid fa-lg fa-ethernet me-1"></i>
                                            <i class="fa-solid fa-lg fa-gears"></i>
                                        </button>
                                        <button v-if="updated_oss.includes(oss[selected_marker.os])" class="btn text-white fs-5 me-1 rounded" style="width: 10%;" @click="target_mode='pings'; selected_target = selected_target_default; selected_target.type='ping'; target_data_mode='alias'; resetObject(ping_target_data, null); newTargetAlias=null;" :class="{'bg-alchemy bg-gradient': target_mode!='pings', 'btn-alchemy': target_mode=='pings' }">
                                            <i class="fa-solid fa-lg fa-rss"></i>
                                        </button>
                                    </div>
                                    <div class="rounded p-2 w-100" style="height: 430px;" >
                                        <!-- New target :: Interfaces & Services -->
                                        <div v-show="target_mode=='interfaces_services'" class="input-group flex-nowrap" :class="{'disabled-div': addingTarget || selected_marker.os == 'superficial' }">
                                            <button class="btn bg-alchemy bg-gradient text-white fs-5 me-1" style="width: 25%;">
                                                <i class="fa-solid fa-xl fa-bullseye me-1" :class="{'fa-beat-fade': gettingAvTargets || addingTarget}"></i>
                                                New
                                            </button>
                                            <select class="btn bg-alchemy bg-gradient text-white fs-5 me-1 text-start" style="width: 60%;" v-model="selected_target" :class="{'fa-fade': !markers_targets}" :disabled="gettingAvTargets || addingTarget">
                                                <option v-if="!markers_targets" :value="selected_target_default">Retrieve targets first.</option>
                                                <option v-if="markers_targets" :value="selected_target_default">Select target...</option>
                                                <option v-for="(target, index) in availableTargets" v-bind:key="index+1" :value="target">{{capitalize(target.name) + ` (${target.type})`}}</option>
                                            </select>
                                            <select class="btn bg-alchemy bg-gradient text-white text-start fs-6" style="width: 40%;" v-model="target_data_mode" :disabled="gettingAvTargets || addingTarget || selected_target == selected_target_default">
                                                <option value="alias">Alias</option>
                                                <option v-if="selected_target.type == 'interface'" value="usage">Usage Limit (%)</option>
                                                <option v-if="selected_target.type == 'interface'" value="capacity">Capacity (M,G)</option>
                                                <option value="description">Description (Read Only)</option>
                                            </select>
                                            <!-- Description -->
                                            <div v-if="target_data_mode == 'description'" class="w-75">
                                                <input type="text" class="btn bg-alchemy w-100 text-white fs-5 me-1" style="cursor: text;" placeholder="Target Alias" :value="selected_target.description" :disabled="selected_target == selected_target_default" readonly>
                                            </div>
                                            <!-- Alias -->
                                            <div v-if="target_data_mode == 'alias'" class="w-75">
                                                <input type="text" class="btn bg-alchemy w-100 text-white fs-5 me-1" style="cursor: text;" placeholder="Target Alias" v-model="newTargetAlias" :disabled="selected_target == selected_target_default">
                                            </div>
                                            <!-- Usage -->
                                            <div v-if="target_data_mode == 'usage'" class="w-75 me-1 ">
                                                <input type="number" class="btn bg-alchemy text-white fs-5 w-100" style="width: 15%;" title="Usage limit (only for interfaces)" placeholder="Usage limit" v-model="interface_target_data.usage_limit" :disabled="selected_target.type != 'interface'">
                                            </div>
                                            <!-- Capacity -->
                                            <div v-if="target_data_mode == 'capacity'" class="w-75 me-1">
                                                <input type="number" class="btn bg-alchemy text-white fs-5" style="width: 54%;" title="Capacity" placeholder="Value" v-model="interface_target_data.capacity" :disabled="selected_target.type != 'interface'">
                                                <select class="btn bg-alchemy bg-gradient text-white fs-5" style="width: 45%;" v-model="interface_target_data.units" :disabled="gettingAvTargets || addingTarget || selected_target == selected_target_default">
                                                    <option :value="null">Units...</option>
                                                    <option value="mb">Mbps</option>
                                                    <option value="gb">Gbps</option>
                                                </select>
                                            </div>
                                            <button class="btn fs-5 rounded me-1" style="width: 40%;" :title="selected_target.description" :disabled="selected_target == selected_target_default" :class="{'btn-alchemy-success': selected_target.state=='running' || selected_target.state=='up', 
                                                                                                'btn-alchemy-danger': selected_target.state!='running' && selected_target.state!='up'}">
                                                {{ String(selected_target.state).toUpperCase() }}
                                            </button>
                                            <button class="btn fs-5 rounded me-1" style="width: 15%;" :disabled="selected_target == selected_target_default" :class="{'btn-alchemy-success': selected_target.state=='running' || selected_target.state=='up', 
                                                                                                          'btn-alchemy-danger': selected_target.state!='running' && selected_target.state!='up'}">
                                                <i class="fa-solid fa-xl" :class="{'fa-ethernet': selected_target.type == 'interface', 'fa-gears': selected_target.type != 'interface' }"></i>
                                            </button>
                                            <button class="btn btn-alchemy-dark bg-gradient fs-5 rounded" style="width: 10%;" @click="addTarget();" :disabled="selected_target == selected_target_default">
                                                <i class="fa-solid fa-xl fa-plus" :class="{'fa-beat-fade': addingTarget}"></i>
                                            </button>
                                        </div>
                                        <!-- New target :: Pings -->
                                        <div v-show="target_mode=='pings'" class="input-group flex-nowrap" :class="{'disabled-div': addingTarget || selected_marker.os == 'superficial' }">
                                            <button class="btn bg-alchemy bg-gradient text-white fs-5 me-1 rounded" style="width: 25%;">
                                                <i class="fa-solid fa-xl fa-bullseye me-1" :class="{'fa-beat-fade': gettingAvTargets || addingTarget}"></i>
                                                New
                                            </button>
                                            <input class="btn bg-alchemy text-white fs-5 me-1" style="width: 60%; cursor: text;" type="text" v-model="selected_target.name" placeholder="Ping Destination">
                                            <button class="btn fs-6 rounded me-1" style="width: 20%;" title="Calculate Jitter" :class="{'btn-alchemy': ping_target_data.with_jitter, 'bg-alchemy': !ping_target_data.with_jitter}" :disabled="!selected_target.name" @click="ping_target_data.with_jitter = !ping_target_data.with_jitter; target_data_mode='alias';">
                                                <i class="fa-solid fa-xl fa-clock me-1"></i>
                                                <i class="fa-solid fa-xl fa-timeline"></i>
                                            </button>
                                            <select class="btn bg-alchemy bg-gradient text-white fs-6" style="width: 60%;" v-model="target_data_mode" :disabled="addingTarget || !selected_target.name">
                                                <option value="alias">Alias</option>
                                                <option value="sr_lw_limit">Success Rate Lower Limit (%)</option>
                                                <option v-if="false" value="sr_up_limit">Success Rate Upper Limit (%)</option>
                                                <option v-if="false" value="lat_lw_limit">Latency Lower Limit (ms)</option>
                                                <option value="lat_up_limit">Latency Upper Limit (ms)</option>
                                                <option v-if="ping_target_data.with_jitter && false" value="jit_lw_limit">Jitter Lower Limit (ms)</option>
                                                <option v-if="ping_target_data.with_jitter" value="jit_up_limit">Jitter Upper Limit (ms)</option>
                                            </select>
                                            <!-- Alias -->
                                            <div v-if="target_data_mode == 'alias'" class="w-75">
                                                <input type="text" class="btn bg-alchemy w-100 text-white fs-5" style="cursor: text;" placeholder="Target Alias" v-model="newTargetAlias">
                                            </div>
                                            <!-- Success Rate -->
                                            <div v-if="target_data_mode == 'sr_lw_limit'" class="w-75 me-1">
                                                <input type="number" class="btn bg-alchemy text-white fs-5 w-100" style="width: 15%;" title="Success Rate Lower Limit" placeholder="Value" v-model="ping_target_data.success_rate_lower_limit" :disabled="!selected_target.name">
                                            </div>
                                            <div v-if="target_data_mode == 'sr_up_limit'" class="w-75 me-1">
                                                <input type="number" class="btn bg-alchemy text-white fs-5 w-100" style="width: 15%;" title="Success Rate Upper Limit" placeholder="Value" v-model="ping_target_data.success_rate_upper_limit" :disabled="!selected_target.name">
                                            </div>
                                            <!-- Latency -->
                                            <div v-if="target_data_mode == 'lat_lw_limit'" class="w-75 me-1">
                                                <input type="number" class="btn bg-alchemy text-white fs-5 w-100" style="width: 15%;" title="Latency Lower Limit" placeholder="Value" v-model="ping_target_data.latency_lower_limit" :disabled="!selected_target.name">
                                            </div>
                                            <div v-if="target_data_mode == 'lat_up_limit'" class="w-75 me-1">
                                                <input type="number" class="btn bg-alchemy text-white fs-5 w-100" style="width: 15%;" title="Latency Upper Limit" placeholder="Value" v-model="ping_target_data.latency_upper_limit" :disabled="!selected_target.name">
                                            </div>
                                            <!-- Jitter -->
                                            <div v-if="target_data_mode == 'jit_lw_limit'" class="w-75 me-1">
                                                <input type="number" class="btn bg-alchemy text-white fs-5 w-100" style="width: 15%;" title="Jitter Lower Limit" placeholder="Value" v-model="ping_target_data.jitter_lower_limit" :disabled="!selected_target.name">
                                            </div>
                                            <div v-if="target_data_mode == 'jit_up_limit'" class="w-75 me-1">
                                                <input type="number" class="btn bg-alchemy text-white fs-5 w-100" style="width: 15%;" title="Jitter Upper Limit" placeholder="Value" v-model="ping_target_data.jitter_upper_limit" :disabled="!selected_target.name">
                                            </div>
                                            <!-- Type and End -->
                                            <button class="btn btn-alchemy fs-5 rounded me-1" style="width: 15%;" :disabled="!selected_target.name">
                                                <i class="fa-solid fa-xl" :class="{'fa-rss': selected_target.type == 'ping', 'fa-gears': selected_target.type != 'interface' }"></i>
                                            </button>
                                            <button class="btn btn-alchemy-dark bg-gradient fs-5 rounded" style="width: 10%;" @click="selected_target.type='ping'; addTarget(); " :disabled="!selected_target.name">
                                                <i class="fa-solid fa-xl fa-plus" :class="{'fa-beat-fade': addingTarget}"></i>
                                            </button>
                                        </div>
                                        <div class="mt-3 rounded" style="background-color: Black; height: 2px;"></div>
                                        <!-- Current targets -->
                                        <div class="input-group flex-nowrap mt-3">
                                            <button class="btn bg-alchemy bg-gradient text-white me-1 fs-4" style="width: 15%;" title="Device Total Targets, click here to refresh active targets." @click="getTargets(selected_marker); selected_target_chart=null;">
                                                <i class="fa-solid fa-xl fa-refresh me-2" :class="{'fa-spin': gettingMarkerTargets || deletingTarget}"></i>
                                                {{markerTargets.length}}
                                            </button>
                                            <input type="text" class="btn bg-alchemy-two text-white fw-light fs-4 text-start w-50 me-1" style="letter-spacing: 5px; cursor: default;" value="Active Targets" readonly>
                                            <input v-if="target_view=='list'" type="text" class="btn bg-alchemy-two text-white w-50" style="cursor: text;" placeholder="Filter by target name/alias." v-model="searchWordTarget">
                                            <select v-if="target_view=='chart'" class="btn bg-alchemy w-50 text-white fs-4 me-1" v-model="selected_target_chart" @change="target_chart_ready=false; target_history=null; target_gm=null;" :disabled="gettingMarkerTargets || addingTarget">
                                                <option :value="null">Select target...</option>
                                                <option v-for="(tc, tci) in markerTargets" v-bind:key="tci+1" :value="tc">{{capitalize(tc.name) + ` (${tc.type})`}}</option>
                                            </select>
                                            <button class="btn bg-alchemy bg-gradient text-white fs-4" style="width: 15%;" title="Click to change the target view." @click="toggleTargetView">
                                                <i class="fa-solid fa-xl" :class="{'fa-list': target_view == 'chart', 'fa-chart-line': target_view == 'list' }"></i>
                                            </button>
                                        </div>
                                        <!-- List mode -->
                                        <div v-if="target_view == 'list'">
                                            <div class="bg-black rounded mt-2" :class="{'disabled-div': deletingTarget || gettingMarkerTargets}">
                                                <div class="mt-1" id="markers_targets">
                                                    <div id="markerTargetsTable">   
                                                        <div class="tableFixHead" style="height: 430px;">
                                                            <table>
                                                                <thead>
                                                                    <tr>
                                                                        <th class="fw-light bg-alchemy-two text-white fs-5 border-bottom" title="Target Name">
                                                                            <select class="btn bg-transparent text-white fs-5" v-model="target_show_type">
                                                                                <option value="name">Name</option>
                                                                                <option value="alias">Alias</option>
                                                                            </select>
                                                                        </th>
                                                                        <th class="fw-light bg-alchemy-two text-white fs-5 border-bottom" title="Target Type">
                                                                            Type
                                                                        </th>
                                                                        <th class="fw-light bg-alchemy-two text-white fs-5 border-bottom"  title="Target State">
                                                                            State
                                                                        </th>
                                                                        <th class="fw-light bg-alchemy-two text-white fs-5 border-bottom" title="Target Last Update">
                                                                            <i class="fa-solid fa-lg fa-clock"></i>
                                                                        </th>
                                                                        <th class="fw-light bg-alchemy-two text-white fs-5 border-bottom" title="Delete target.">
                                                                            <i class="fa-solid fa-lg fa-trash"></i>
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(mtarget, mtIndex) in filteredMarkerTargets" v-bind:key="mtIndex+1"> <!-- Content Row -->
                                                                        <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50); width: 50px;">
                                                                            <input class="fw-light fs-6 border-0 rounded text-white text-center" :value="mtarget[target_show_type]" style="cursor: default; background-color: transparent;" readonly>
                                                                        </td>
                                                                        <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50); width: 50px;">
                                                                            <button class="btn btn-alchemy bg-gradient" :title="String(mtarget.type).toUpperCase()" readonly>
                                                                                <i v-if="mtarget.type == 'interface'" class="fa-solid fa-lg fa-ethernet"></i>
                                                                                <i v-if="mtarget.type == 'ping'" class="fa-solid fa-lg fa-rss"></i>
                                                                                <i v-if="mtarget.type == 'os-service'" class="fa-solid fa-lg fa-gears"></i>
                                                                            </button>
                                                                        </td>
                                                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 50px;">
                                                                            <button class="btn fw-light fs-6 w-100" :class="{'btn-alchemy-success': mtarget.state=='running' || mtarget.state=='up', 'btn-alchemy-danger': mtarget.state!='running' && mtarget.state!='up'}">
                                                                                {{ String(mtarget.state).toUpperCase()}}
                                                                            </button>
                                                                        </td>
                                                                        <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50); width: 50px;">
                                                                            <input class="fw-light fs-6 border-0 rounded text-white text-center" :value="mtarget.last_update" style="cursor: default; background-color: transparent;" readonly>
                                                                        </td>
                                                                        <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50); width: 50px;">
                                                                            <button class="btn btn-alchemy-dark bg-gradient fw-light fs-6 w-100" title="Delete target." @click="deleteTarget(mtarget)">
                                                                                <i class="fa-solid fa-lg fa-trash"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="target_view == 'chart'">
                                            <!-- Selection wait mode -->
                                            <div v-if="selected_target_chart == null">
                                                <div class="text-white fw-light fs-2" style="margin-top: 12%; margin-left: 0%;">
                                                    <i class="fa-solid fa-xl fa-bullseye fa-beat-fade"></i>
                                                    <p class="text-white fw-light">Select a target and visualize the data.</p>
                                                </div>
                                            </div>
                                            <!-- Target history -->
                                            <div class="input-group flex-nowrap mt-1" v-if="selected_target_chart != null">
                                                <div class="bg-alchemy-two me-1 p-1 rounded" style="width: 20%; height: 430px;">
                                                    <p class="fs-2 text-white fw-light">Interval</p>
                                                    <div class="input-group flex-nowrap p-1">
                                                        <button class="btn btn-alchemy-dark bg-gradient w-25 fs-4 rounded" style="cursor: default; border-right: solid 3px black;" :disabled="gettingHistory">
                                                            <i class="fa-solid fa-xl fa-hourglass-start"></i>
                                                        </button>
                                                        <div class="w-75">
                                                            <input type="date" class="btn btn-alchemy-dark bg-gradient w-100 fs-5" value="2023-03-15" v-model="tstart.date" :disabled="gettingHistory">
                                                            <input type="time" class="btn btn-alchemy-dark bg-gradient w-100 fs-5 mt-1" value="00:00" v-model="tstart.time" :disabled="gettingHistory">
                                                        </div>
                                                    </div>
                                                    <div class="input-group flex-nowrap p-1 mt-1">
                                                        <button class="btn btn-alchemy-dark bg-gradient w-25 fs-4 rounded" style="cursor: default; border-right: solid 3px black;" @click="setNow" :disabled="gettingHistory">
                                                            <i class="fa-solid fa-xl fa-hourglass-end"></i>
                                                        </button>
                                                        <div class="w-75">
                                                            <input type="date" class="btn btn-alchemy-dark bg-gradient w-100 fs-5" value="2023-03-15" v-model="tend.date" :disabled="gettingHistory">
                                                            <input type="time" class="btn btn-alchemy-dark bg-gradient w-100 fs-5 mt-1" value="00:00" v-model="tend.time" :disabled="gettingHistory">
                                                        </div>
                                                    </div>
                                                    <div class="input-group flex-nowrap mt-1">
                                                        <button class="btn btn-alchemy-dark bg-gradient w-50 fs-5 rounded me-1" @click="getHistoryReport('target_history', selected_target_chart.name)" :disabled="downloading || gettingTargetHistory">
                                                            <i class="fa-solid fa-xl fa-file-arrow-down" :class="{'fa-beat-fade': downloading}"></i>
                                                        </button>
                                                        <button class="btn btn-alchemy-dark bg-gradient w-50 fs-5" @click="getTargetHistoryGraphs(false)" :disabled="downloading || gettingTargetHistory">
                                                            <i class="fa-solid fa-xl fa-arrow-right" :class="{'fa-beat-fade': gettingTargetHistory}"></i>
                                                        </button>
                                                    </div>
                                                    <div v-if="target_chart_ready" class="input-group flex-nowrap mt-2">
                                                        <button class="btn btn-alchemy-dark bg-gradient w-25 fs-5 rounded">
                                                            <i class="fa-solid fa-xl fa-chart-line"></i>
                                                        </button>
                                                        <select v-if="selected_target_chart.type=='interface'" v-model="target_gm" class="btn btn-alchemy-dark w-75 fs-6 rounded border-bottom-alchemy" >
                                                            <option :value="null">Rates (Mbps)</option>
                                                            <option v-if="oss_wf_rates.includes(selected_marker.os)" value="pps">Packets / Sec</option>
                                                            <option v-if="oss_wf_rates.includes(selected_marker.os)" value="broad_pps">Broadcast P/S</option>
                                                            <option v-if="oss_wf_rates.includes(selected_marker.os)" value="terr_pps">Total Errors P/S</option>
                                                        </select>
                                                        <select v-if="selected_target_chart.type=='ping'" v-model="target_gm" class="btn btn-alchemy-dark w-75 fs-6 rounded border-bottom-alchemy" >
                                                            <option :value="null">Success Rate</option>
                                                            <option value="stats">Ping Statistics</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="bg-transparent rounded" style="width: 80%; height: 100%;">
                                                    <div v-if="!target_chart_ready" class="">
                                                        <div class="text-white fw-light fs-2" style="margin-top: 12%; margin-left: 0%; ">
                                                            <i class="fa-solid fa-xl fa-chart-line" :class="{'fa-beat-fade': gettingTargetHistory}"></i>
                                                            <p v-if="!gettingTargetHistory" class="text-white fw-light">Set the interval and generate the chart.</p>
                                                            <p v-if="gettingTargetHistory" class="text-white fw-light">Getting chart data.</p>
                                                        </div>
                                                    </div>
                                                    <div v-if="selected_target_chart.type == 'interface' && target_chart_ready && target_history != null" class="bg-alchemy-two" style="height: 420px;">
                                                        <div v-if="target_gm == null">
                                                            <InterfacesGraph chart-id="target_rates_graph" :chart-data="target_history.rates"></InterfacesGraph>
                                                        </div>
                                                        <div v-if="target_gm == 'pps'">
                                                            <InterfacesGraph chart-id="target_pps_graph" :chart-data="target_history.pps"></InterfacesGraph>
                                                        </div>
                                                        <div v-if="target_gm == 'broad_pps'">
                                                            <InterfacesGraph chart-id="target_pps_graph" :chart-data="target_history.broad_pps"></InterfacesGraph>
                                                        </div>
                                                        <div v-if="target_gm == 'terr_pps'">
                                                            <InterfacesGraph chart-id="target_pps_graph" :chart-data="target_history.terr_pps"></InterfacesGraph>
                                                        </div>
                                                    </div>
                                                    <div v-if="selected_target_chart.type == 'ping' && target_chart_ready && target_history != null" class="bg-alchemy-two" style="height: 420px;">
                                                        <div v-if="target_gm == null">
                                                            <PercentGraph chart-id="target_sr_graph" :chart-data="target_history.ping_sr"></PercentGraph>
                                                        </div>
                                                        <div v-if="target_gm == 'stats'">
                                                            <FreeGraph chart-id="target_stats_graph" :chart-data="target_history.ping_stats"></FreeGraph>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Alerts -->
                                <div v-if="detail_mode=='alerts'">
                                    <div class="input-group flex-nowrap">
                                        <div class="me-3" style="width: 65%;">
                                            <input type="text" class="btn text-white fw-light fs-2 text-start w-100" style="letter-spacing: 5px; cursor: default; opacity: 1.0;" :value="`Alerts - ${selected_marker.alerts.length} detected.`" disabled>
                                        </div>
                                        <div v-if="false" class="input-group flex-nowrap" style="width: 35%;">
                                            <input type="text" class="btn text-white text-start fw-light fs-2 w-100" style="letter-spacing: 5px; cursor: default; opacity: 1.0;" value="Notificators" disabled>
                                            <button class="btn btn-alchemy rounded fs-4" style="width: 15%;" @click="saveNotificators" :disabled="savingNotificators">
                                                <i class="fa-solid fa-lg fa-save" :class="{'fa-beat-fade': savingNotificators}"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="input-group flex-nowrap mt-1">
                                        <div class="bg-black rounded me-3" style="width: 100%">
                                            <div class="mt-1" id="markers_notificators">
                                                <div id="markerTargetsTable">   
                                                    <div class="tableFixHead" style="height: 500px;">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="fw-light bg-alchemy text-white fs-5 border-bottom text-start" title="Alert Name">
                                                                        Name
                                                                    </th>
                                                                    <th class="fw-light bg-alchemy text-white fs-5 border-bottom text-start" title="Alert Description">
                                                                        Description
                                                                    </th>
                                                                    <th class="fw-light bg-alchemy text-white fs-5 border-bottom"  title="Alert Type">
                                                                        <i class="fa-solid fa-lg fa-cube"></i>
                                                                    </th>
                                                                    <th class="fw-light bg-alchemy text-white fs-5 border-bottom" title="Alert Severity">
                                                                        <i class="fa-solid fa-lg fa-triangle-exclamation"></i>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(m_alert, ale_i) in selected_marker.alerts" v-bind:key="ale_i+1"> <!-- Content Row -->
                                                                    <td class="text-center bg-black" style="width: 30%; border-bottom: solid 1px rgb(50,50,50);">
                                                                        <input class="fw-bold fs-6 border-0 rounded text-white text-start w-100" :value="String(m_alert.name).toUpperCase()" style="cursor: default; background-color: transparent;" readonly>
                                                                    </td>
                                                                    <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                                                        <input class="fw-light fs-6 border-0 rounded text-white text-start w-100" :value="m_alert.description" style="cursor: default; background-color: transparent;" readonly>
                                                                    </td>
                                                                    <td class="text-center bg-black" style="width: 2%; border-bottom: solid 1px rgb(50,50,50); width: 50px;">
                                                                        <button class="btn btn-alchemy-dark bg-gradient fw-light fs-6" :title="`Alert Type : ${m_alert.type}`">
                                                                            <i class="fa-solid fa-lg" :class="{'fa-microchip': m_alert.type=='cpu',
                                                                                                               'fa-memory':    m_alert.type=='memory',
                                                                                                               'fa-rss':       m_alert.type=='ping',
                                                                                                               'fa-gear':      m_alert.type=='process',
                                                                                                               'fa-clock':     m_alert.type=='process-timeout',
                                                                                                               'fa-ethernet':  m_alert.type=='target-interface',
                                                                                                               'fa-gears':     m_alert.type=='target-os-service' }"></i>
                                                                        </button>
                                                                    </td>
                                                                    <td class="text-center bg-transparent" style="border-bottom: solid 1px rgb(50,50,50);">
                                                                        <button class="btn bg-gradient fw-light fs-6 border-0 rounded text-center" :class="{'btn-alchemy-success': m_alert.severity == 'CLEAR', 'btn-alchemy-warning': m_alert.severity == 'MINOR', 'btn-alchemy-danger': m_alert.severity == 'MAJOR' }" :title="`Severity: ${m_alert.severity}`">
                                                                            <i class="fa-solid fa-lg fa-triangle-exclamation" :class="{'fa-beat-fade': m_alert.severity != 'CLEAR'}"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="false" class="bg-black rounded" :class="{'disabled-div': savingNotificators}" style="width: 35%">
                                            <div class="mt-1" id="markers_notificators">
                                                <div id="markerTargetsTable">   
                                                    <div class="tableFixHead" style="height: 500px;">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="fw-light bg-alchemy text-white fs-5 border-bottom" title="Target Name">
                                                                        Name / Type
                                                                    </th>
                                                                    <th class="fw-light bg-alchemy text-white fs-5 border-bottom" title="Target Name">
                                                                        <i class="fa-solid fa-lg fa-paper-plane"></i>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(m_ntfs, ntfs_i) in selected_marker.notificators" v-bind:key="ntfs_i+1"> <!-- Content Row -->
                                                                    <td class="text-center bg-black" style="width: 80%; border-bottom: solid 1px rgb(50,50,50);">
                                                                        <input class="fw-light fs-6 border-0 rounded text-white text-center w-100" :value="`${m_ntfs.name} / ${m_ntfs.type.replace('_',' ').toUpperCase()}`" style="cursor: default; background-color: transparent;" readonly>
                                                                    </td>
                                                                    <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                                                        <button class="btn" :class="{'btn-alchemy': m_ntfs.include, 'btn-alchemy-off': !m_ntfs.include}" @click="m_ntfs.include = !m_ntfs.include">
                                                                            <i class="fa-solid fa-lg" :class="{'fa-check': m_ntfs.include, 'fa-minus': !m_ntfs.include}"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Tester -->
                                <div v-if="detail_mode=='tester'">
                                    <div class="input-group flex-nowrap">
                                        <button class="btn bg-transparent text-white fs-1 ms-1 rounded" style="width: 10%; pointer-events: none;">
                                            <i class="fa-solid fa-flask"></i>
                                        </button>
                                        <input type="text" class="btn text-white fw-light fs-2 text-center w-100" style="letter-spacing: 5px; cursor: default; opacity: 1.0;" disabled value="Test Area" readonly>
                                        <button class="btn bg-transparent text-white fs-1 ms-1 rounded" style="width: 10%; pointer-events: none;">
                                            <i class="fa-solid fa-flask"></i>
                                        </button>
                                    </div>
                                    

                                    <!-- MODE : Ping -->
                                    <div v-if="tester_mode == 'ping'">
                                        <div class="input-group flex-nowrap">
                                            <input type="text" class="btn text-white fw-light fs-2 text-center w-100" style="letter-spacing: 5px; cursor: default; opacity: 1.0;" disabled value="Ping" readonly>
                                            <input type="text" class="btn bg-alchemy text-white fw-light fs-2 text-center w-100" style="letter-spacing: 2px; cursor: text; opacity: 1.0;" v-model="tester.ping.ip">
                                        </div>
                                        <div class="input-group flex-nowrap border">

                                        </div>
                                    </div>

                                    <!-- MODE : Terminal -->
                                    <div v-if="tester_mode == 'ping'">

                                    </div>

                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- LABORATORY Modal -->
    <div class="modal fade" id="tester" tabindex="-1">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content bg-black">
                <!-- Header -->
                <div class="modal-header border-0 bg-alchemy-two bg-gradient">
                    <div class="input-group flex-nowrap">
                        <button class="btn rounded text-white fs-4" style="width: 8%; pointer-events:none;" title="Alchemy Laboratory">
                            <i class="fa-solid fa-2xl fa-flask-vial"></i>
                        </button>
                        <button class="btn text-start fs-1 text-white" style="width: 97%; cursor: default; letter-spacing: 5px;">Alchemy's Laboratory</button>
                        <button class="btn btn-danger rounded" title="Close device detail." data-bs-dismiss="modal" style="width: 5%" @click="cleanLAB">
                            <i class="fa-solid fa-2xl fa-close"></i>
                        </button>

                    </div>
                </div>
                <!-- Body -->
                <div class="modal-body bg-black" style="overflow: hidden;">
                    <div class="row">
                        <!-- Selection -->
                        <div class="col-md-1">
                            <div class="p-2 rounded bg-alchemy-two bg-gradient" style="height: 650px;" :class="{'disabled-div': gettingMarkers}">
                                <!-- Ping -->
                                <button class="btn fs-3 w-100" @click="tester_mode='ping'" :class="{'btn-alchemy-success': tester_mode=='ping', 'btn-alchemy-dark': tester_mode!='ping'}" title="Ping (Live)">
                                    <i class="fa-solid fa-xl fa-rss"></i>
                                </button>
                                <!-- Log Checker -->
                                <button class="btn fs-3 w-100 mt-2" @click="tester_mode='logs'"  :class="{'btn-alchemy-success': tester_mode=='logs', 'btn-alchemy-dark': tester_mode!='logs'}" title="Log checker.">
                                    <i class="fa-solid fa-xl fa-clock-rotate-left"></i>
                                </button>
                                <!-- ? -->
                                <button class="btn fs-3 w-100 mt-2" :class="{'btn-alchemy-success': tester_mode=='trace', 'btn-alchemy-dark': tester_mode!='trace'}" disabled>
                                    <i class="fa-solid fa-xl fa-circle-question"></i>
                                </button>
                                <!-- Terminal -->
                                <button class="btn fs-3 w-100 mt-2" :class="{'btn-alchemy-success': tester_mode=='terminal', 'btn-alchemy-dark': tester_mode!='terminal'}" disabled>
                                    <i class="fa-solid fa-xl fa-circle-question"></i>
                                </button>
                                <!-- Reporter -->
                                <button class="btn fs-3 w-100 mt-2" :class="{'btn-alchemy-success': tester_mode=='reporter', 'btn-alchemy-dark': tester_mode!='reporter'}" disabled>
                                    <i class="fa-solid fa-xl fa-circle-question"></i>
                                </button>
                            </div>
                        </div>
                        <!-- Content of selection. -->
                        <div class="col-md-11">
                            <!-- MODE : Ping -->
                            <div v-show="tester_mode == 'ping'">
                                <div class="input-group flex-nowrap">
                                    <input type="text" class="btn text-white fw-light fs-2 w-100" disabled style="letter-spacing: 5px; cursor: default; opacity: 1.0;" value="Ping" readonly>
                                </div>
                                <div class="input-group flex-nowrap rounded bg-dark p-2" :class="{'disabled-div': pinging}">
                                    <button class="btn rounded text-white fs-6" style="width: 8%; pointer-events:none;" title="Device selection.">
                                        <i class="fa-solid fa-2xl fa-desktop"></i>
                                    </button>
                                    <div class="input-group flex-nowrap p-1">
                                        <button class="btn btn-alchemy rounded me-1" style="width: 5%" @click="getMarkers">
                                            <i class="fa-solid fa-xl fa-refresh" :class="{'fa-spin': gettingMarkers}"></i>
                                        </button>
                                        <button class="btn btn-alchemy rounded me-1" style="width: 5%" title="Total devices | Matchs">
                                            {{filteredMarkers.length}}
                                        </button>
                                        <input class="btn fw-light bg-black rounded text-white fs-6 me-1" type="text" style="cursor: text; width: 20%;" placeholder="Search" v-model="searchWord" @keydown="tester_ping.device=null">
                                        <select class="btn fw-light bg-black rounded fs-6 text-start text-white rounded me-1" style="width: 20%;" v-model="search_std_type">
                                            <option value="name">By Name</option>
                                            <option value="alias">By Alias</option>
                                            <option value="ip">By IP Address</option>
                                            <option value="service_key">By Service Key</option>
                                        </select>
                                        <select class="btn btn-alchemy text-start fw-bold rounded" style="width: 60%; font-size: 14px;" title="NAME | ALIAS | IP | SERVICE KEY" :disabled="gettingMarkers" v-model="tester_ping.device">
                                            <option :value="null">Select a device to ping...</option>
                                            <option :value="dv" v-for="(dv, dix) in filteredMarkers" v-bind:key="dix+1">{{`${dv.name} | ${dv.alias} | ${dv.ip} | ${dv.service_key}`}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="input-group flex-nowrap">
                                    <div class="w-50">
                                    </div>
                                    <div class="vertical-row"></div>
                                </div>
                                <div class="input-group flex-nowrap" :class="{'disabled-div': tester_ping.device == null || pinging}">
                                    <div style="width:33%"></div>
                                    <div class="input-group flex-nowrap rounded bg-dark p-2" style="width:33%">
                                        <button class="btn rounded text-white fs-6" style="width: 15%; pointer-events:none;" title="Ping settings.">
                                            <i class="fa-solid fa-2xl fa-rss"></i>
                                        </button>
                                        <div v-if="tester_ping.device == null" style="width: 70%; color: white;">...</div>
                                        <input v-if="tester_ping.device != null" class="btn fw-light bg-transparent rounded text-white fs-6" type="text" style="cursor: text; width: 70%" :value="`Ping to: ${tester_ping.device.ip}`">
                                        <button class="btn btn-success rounded" style="width: 15%;"  @click="ping();" :disabled="tester_ping.device == null || pinging">
                                            <i class="fa-solid fa-xl fa-paper-plane" :class="{'fa-beat': pinging}"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="input-group flex-nowrap mb-1">
                                    <input type="text" class="btn text-white fw-light fs-2 text-start w-100" :class="{'fa-fade': pinging}" disabled style="letter-spacing: 5px; cursor: default; opacity: 1.0;" :value="`Results (${Object.keys(tester_ping.results).length})`" readonly>
                                    <button class="btn btn-danger rounded fs-6" style="width: 8%;" title="Device selection." @click="tester_ping.results = {}" :disabled="pinging">
                                        <i class="fa-solid fa-xl fa-trash"></i>
                                    </button>
                                </div>
                                <div class="border-top border-bottom border-dark mt-2 p-2" style="overflow-y: scroll; height: 375px;">
                                    <div v-if="Object.keys(tester_ping.results).length > 0" >
                                        <div class="rounded mb-1" :class="{'fa-fade': rv.pinging}" v-for="(rv, rk, ri) in tester_ping.results" v-bind:key="ri+1">
                                            <div class="bg-dark rounded p-1">
                                                <div class="input-group flex-nowrap p-1">
                                                    <div class="bg-black rounded p-1" style="width: 25%; height: 160px;">
                                                        <button class="btn text-start text-info fw-bold fs-6 w-100">
                                                            <i class="fa-solid fa-xl fa-desktop me-2"></i>
                                                            {{`${rv.name}`}}
                                                        </button>
                                                        <button class="btn text-start text-info fw-bold fs-6 w-100">
                                                            <i class="fa-solid fa-xl fa-id-badge ms-1 me-2"></i>
                                                            {{`${rv.alias}`}}
                                                        </button>
                                                        <button class="btn text-start text-primary fw-bold fs-6 w-100">
                                                            <i class="fa-solid fa-xl fa-network-wired me-2"></i>
                                                            {{`${rv.ip}`}}
                                                        </button>
                                                        <button class="btn text-start text-success fw-bold fs-6 w-100">
                                                            <i class="fa-solid fa-xl fa-tag me-2 ms-2"></i>
                                                            {{`${rv.serkey}`}}
                                                        </button>
                                                    </div>
                                                    <div class="bg-black rounded p-1 ms-1" style="width: 15%;">
                                                        <button class="btn text-warning fw-bold fs-5 w-100 mt-3" title="Samples ready.">
                                                            <i class="fa-solid fa-2xl fa-vials"></i>
                                                        </button>
                                                        <div class="text-white fs-4">
                                                            Samples
                                                        </div>
                                                        <div class="text-white fs-4">
                                                            {{`${rv.data.length}`}}
                                                        </div>
                                                    </div>
                                                    <div class="bg-black rounded p-1 ms-1" style="width:60%; height: 160px; overflow-y: scroll;">
                                                        <div class="input-group border-bottom border-dark thehover mb-1 w-100" v-for="(sample, si) in rv.data" v-bind:key="si+1">            
                                                            <div class="input-group flex-nowrap"  style="width: 7%;">
                                                                <input type="text" class="btn bg-black text-white text-center w-100" style="pointer-events: none;"  :value="si+1" readonly>
                                                            </div>
                                                            <div class="input-group flex-nowrap" style="width: 20%;">
                                                                <button class="btn text-warning fw-bold fs-6 w-25" :title="`Timestamp for ${sample.ping.endpoint}`">
                                                                    <i class="fa-solid fa-xl fa-calendar-day"></i>
                                                                </button>
                                                                <input type="text" class="btn bg-black text-white text-start w-75" style="pointer-events: none;" :value="sample.ping.ts" readonly>
                                                            </div>
                                                            <div class="input-group flex-nowrap" style="width: 20%;">
                                                                <button class="btn text-primary fw-bold fs-6" title="Latency">
                                                                    <i class="fa-solid fa-xl fa-clock"></i>
                                                                </button>
                                                                <input type="text" class="btn bg-black text-white text-start w-75" style="pointer-events: none;" :value="`${sample.ping.latency ? sample.ping.latency: '-'} ms`" readonly>
                                                            </div>
                                                            <div class="input-group flex-nowrap" style="width: 20%;">
                                                                <button class="btn text-info fw-bold fs-6 w-25" title="Jitter">
                                                                    <i class="fa-solid fa-xl fa-j"></i>
                                                                </button>
                                                                <input type="text" class="btn bg-black text-white text-start w-75" style="pointer-events: none;" :value="`${sample.ping.jitter ? sample.ping.jitter: '-'} ms`" readonly>
                                                            </div>
                                                            <div class="input-group flex-nowrap" style="width: 20%;">
                                                                <button class="btn text-success fw-bold fs-6" title="Success Rate" :class="{'text-success': sample.ping.connectivity, 'text-danger': !sample.ping.connectivity}">
                                                                    <i class="fa-solid fa-xl fa-circle-check"></i>
                                                                </button>
                                                                <input type="text" class="btn bg-black text-white text-start w-75" style="pointer-events: none;" :value="`${sample.ping.success}%`" readonly>
                                                            </div>
                                                            <button class="btn fw-bold fs-6 rounded" :class="{'btn-success': sample.ping.connectivity, 'btn-danger fa-fade': !sample.ping.connectivity}" :title="`${sample.ping.connectivity ? 'OK':'Unreachable device through ICMP.'}`" style="width: 13%;">
                                                                <i class="fa-solid fa-xl" :class="{'fa-check': sample.ping.connectivity, 'fa-close': !sample.ping.connectivity}"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="Object.keys(tester_ping.results).length == 0" >
                                        <div class="text-white fs-1" style="margin-top: 10%;">
                                            <i class="fa-solid fa-xl fa-rss fa-fade"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="tester_mode == 'logs'">
                                <div class="input-group flex-nowrap">
                                    <input type="text" class="btn text-white fw-light fs-2 w-100" :class="{'fa-fade': getting_logs}" disabled style="letter-spacing: 5px; cursor: default; opacity: 1.0;" value="Logs" readonly>
                                </div>
                                <div class="input-group flex-nowrap rounded bg-dark p-2" :class="{'disabled-div': getting_logs}">
                                    <button class="btn rounded text-white fs-6" style="width: 8%; pointer-events:none;" title="Device selection.">
                                        <i class="fa-solid fa-2xl fa-desktop"></i>
                                    </button>
                                    <div class="input-group flex-nowrap p-1">
                                        <button class="btn btn-alchemy rounded me-1" style="width: 5%" @click="getMarkers">
                                            <i class="fa-solid fa-xl fa-refresh" :class="{'fa-spin': gettingMarkers}"></i>
                                        </button>
                                        <button class="btn btn-alchemy rounded me-1" style="width: 5%" title="Total devices | Matchs">
                                            {{filteredMarkers.length}}
                                        </button>
                                        <input class="btn fw-light bg-black rounded text-white fs-6 me-1" type="text" style="cursor: text; width: 20%;" placeholder="Search" v-model="searchWord" @keydown="tester_logs=cloneObject(tester_logs_def)">
                                        <select class="btn fw-light bg-black rounded fs-6 text-start text-white rounded me-1" style="width: 20%;" v-model="search_std_type">
                                            <option value="name">By Name</option>
                                            <option value="alias">By Alias</option>
                                            <option value="ip">By IP Address</option>
                                            <option value="service_key">By Service Key</option>
                                        </select>
                                        <select class="btn btn-alchemy text-start fw-bold rounded" style="width: 60%; font-size: 14px;" title="NAME | ALIAS | IP | SERVICE KEY" :disabled="gettingMarkers" v-model="tester_logs.device" @change="logs('standard')">
                                            <option :value="null">Select a device to retrieve logs...</option>
                                            <option :value="dv" v-for="(dv, dix) in filteredMarkers" v-bind:key="dix+1">{{`${dv.name} | ${dv.alias} | ${dv.ip} | ${dv.service_key}`}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="input-group flex-nowrap">
                                    <div class="w-50">
                                    </div>
                                    <div class="vertical-row"></div>
                                </div>
                                <div class="input-group flex-nowrap">
                                    <div style="width:25%"></div>
                                    <div class="input-group flex-nowrap bg-dark rounded p-2" style="width: 50%;">
                                        <button class="btn btn-alchemy rounded me-1" @click="logs('standard')" :disabled="!tester_logs.device">
                                            <i class="fa-solid fa-refresh" :class="{'fa-spin': getting_logs}"></i>
                                        </button>
                                        <select class="btn btn-alchemy rounded me-1 w-75" v-model="tester_logs.date" :disabled="!tester_logs.device || getting_logs">
                                            <option :value="null">Select a date.</option>
                                            <option :value="date" v-for="(date, dindex) in tester_logs.logs" :key="dindex">{{date.alias}}</option>
                                        </select>
                                        <select v-if="!tester_logs.date" class="btn btn-alchemy rounded w-25" :disabled="!tester_logs.device || !tester_logs.date || getting_logs">
                                            <option :value="null">Hour</option>
                                        </select>
                                        <select v-if="tester_logs.date" v-model="tester_logs.hour" class="btn btn-alchemy rounded w-25" :disabled="!tester_logs.device || !tester_logs.date || getting_logs">
                                            <option :value="null">Select hour.</option>
                                            <option :value="content" v-for="(content, hour, hindex) in tester_logs.date.data" :key="hindex">{{hour.replace('_',':')}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="input-group flex-nowrap">
                                    <div class="w-50">
                                    </div>
                                    <div class="vertical-row"></div>
                                </div>
                                <div class="bg-dark rounded p-1 mt-1" style="height: 420px;">
                                    <textarea class="p-1 w-100 bg-black text-info rounded border-0" style="height: 100%;" :value="tester_logs.hour" readonly></textarea>
                                </div>


                            </div>
                            <div v-show="tester_mode == 'terminal'">
                                <div class="input-group flex-nowrap">
                                    <input type="text" class="btn text-white fw-light fs-2 text-start w-100" disabled style="letter-spacing: 5px; cursor: default; opacity: 1.0;" value="Terminal" readonly>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import MapViewer from '@/components/apps-components/alchemy/subs/MapViewer.vue'
import HealthGraph from '@/components/apps-components/alchemy/subs/charts/HealthGraph.vue'
import QosGraph from '@/components/apps-components/alchemy/subs/charts/QosGraph.vue'
import FreeGraph from '@/components/apps-components/alchemy/subs/charts/FreeGraph.vue'
import PercentGraph from '@/components/apps-components/alchemy/subs/charts/PercentGraph.vue'
import InterfacesGraph from '@/components/apps-components/alchemy/subs/charts/InterfacesGraph.vue'
import LineChart from '@/components/apps-components/alchemy/subs/charts/LineChart.vue'

// Cloud
// Access Point
import CloudAPRates from '@/components/apps-components/alchemy/subs/charts/cloud/aps/CloudAPRates.vue'
import CloudAPVSP from '@/components/apps-components/alchemy/subs/charts/cloud/aps/CloudAPVSP.vue'
import CloudAPRadioPerc from '@/components/apps-components/alchemy/subs/charts/cloud/aps/CloudAPRadioPerc.vue'
import CloudAPRadioAv from '@/components/apps-components/alchemy/subs/charts/cloud/aps/CloudAPRadioAv.vue'

// Firewall
import CloudFWPS from '@/components/apps-components/alchemy/subs/charts/cloud/firewalls/CloudFWPS.vue'
                      // components/apps-components/alchemy/subs/charts/cloud/firewalls

// Status
import StatusGraph from '@/components/apps-components/alchemy/subs/charts/StatusGraph.vue'

// Timeline
import TimelineDevice from '@/components/apps-components/alchemy/subs/TimelineDevice.vue'


import axios from "axios";

export default {
  name: 'Alchemy',
  components: {
    MapViewer,
    HealthGraph,
    QosGraph,
    InterfacesGraph,
    LineChart,
    FreeGraph,
    PercentGraph,
    // Cloud - APs
    CloudAPRates,
    CloudAPVSP,
    CloudAPRadioPerc,
    CloudAPRadioAv,
    // Cloud FWs
    CloudFWPS,
    // Status
    StatusGraph,
    // Timeline
    TimelineDevice
  },
  data(){
    return {
      // General
      site: null,
      stage: null,
      // Subview
      updated_oss: ['vrp','ios','iosxe','iosxr','reap2900','rax700','ros2800','ubuntu'],
      oss_wf_rates: ['vrp','ios','iosxe','iosxr'],
      mode: null,
      dvmode: "standard_devices",
      focus_mode: false,
      // Status
      pollingListener: -1,
      now: "2022-07-21 10:14:00",
      unique: null,
      statusTimestamp: "-",
      statusText: "Hello",
      searchWord: "",
      sectionView: "list",
      // Refresh
      arid: null,
      autoRefresh: false,
      // Compact
      compact: true,
      // All : null, Superficial:true , Not Superficial: false
      cats: null,
      // Markers
      markerMapKey: 0,
      gettingMarkers: false,
      ping_success_val: 0,
      markers: [],
      refreshMarkers: 0,
      selected_marker: {
            name: null,
            polling: { classIndicator: "btn-dark" },
            connectivity: { value: null, classIndicator: "btn-dark" },
            ping: { success: 0, loss: 0 , classIndicator: "btn-dark" },
            cpu: { value: 0, classIndicator: "btn-dark" },
            memory: { value: 0, classIndicator: "btn-dark" },
            targets: []
      },
      smcopy: null,
      markerView: false,
      icons: {
          //router_alert : { path: require("@/assets/icons/router-alert.png"), size: [40, 25], anchor: [20, 12]},
          //switch: { path: require("@/assets/icons/switch.png"), size: [50, 28], anchor: [25, 14] },
          //server: { path: require("@/assets/icons/server.png"), size: [55, 50], anchor: [27, 25] },
          router : { path: require("@/assets/icons/router.png"), size: [40, 32], anchor: [20, 20]},
          router_alert : { path: require("@/assets/icons/router-alert.png"), size: [40, 32], anchor: [20, 20]},
          router_fail : { path:require("@/assets/icons/router-fail.png"), size: [40, 32], anchor: [20, 20]},
          switch: { path: require("@/assets/icons/switch.png"), size: [40, 32], anchor: [20, 20] },
          switch_alert: { path: require("@/assets/icons/switch-alert.png"), size: [40, 32], anchor: [20, 20] },
          switch_fail: { path: require("@/assets/icons/switch-fail.png"), size: [40, 32], anchor: [20, 20] },
          server: { path: require("@/assets/icons/server.png"), size: [33, 28], anchor: [20, 20] },
          server_alert: { path: require("@/assets/icons/server-alert.png"), size: [33, 28], anchor: [20, 20] },
          server_fail: { path: require("@/assets/icons/server-fail.png"), size: [33, 28], anchor: [20, 20]},
          firewall: {path: require("@/assets/icons/firewall.png"), size: [50, 28], anchor: [25, 5]},
          firewall_alert: {path: require("@/assets/icons/firewall.png"), size: [50, 28], anchor: [25, 5]},
          firewall_fail: {path: require("@/assets/icons/firewall.png"), size: [50, 28], anchor: [25, 5]},
          other: { path: require("@/assets/icons/other.png"), size: [30, 30], anchor: [15, 15] },
          other_alert: { path: require("@/assets/icons/other-alert.png"), size: [30, 30], anchor: [15, 15]},
          other_fail: { path: require("@/assets/icons/other-fail.png"), size: [30, 30], anchor: [15, 15]},
          check: { path: require("@/assets/icons/check.png"), size: [30, 30], anchor: [15, 15]},
          fail: { path: require("@/assets/icons/fail.png"), size: [30, 30], anchor: [15, 15]},
          marker: { path: require("@/assets/icons/marker.png"), size: [30, 30], anchor: [15, 15]},
          role: { path: require("@/assets/icons/marker.png"), size: [30, 45], anchor: [15, 22] }
      },
      search_std_type: 'name',
      // Map
        zoom: 5,
        centerLatitute: 24.41322,
        centerLongitude: -101.219482,
      // Targets
        gettingAvTargets: false,
        availableTargets: [],
        selected_target: {name: null, type: null, state:"state"},
        selected_target_default: {name: null, type: null, state:"state"},
        selected_target_chart: null,
        target_chart_ready: false,
        target_gm: null, // Target Graph Mode
        addingTarget: false,
        deletingTarget: false,
        searchWordTarget: "",
        target_show_type: "name",
        target_view: 'list',
        gettingTargetHistory: false,
        target_history: {},//null,
        tstart: { date: null, time: '00:00' },
        tend: { date: null, time: null },
        target_mode: 'interfaces_services',
        target_data_mode: "alias",
        target_data:{
            capacity: null,
            cunits: 'mb'
        },
        // Interface target
        interface_target_data: {
            usage_limit: null,
            capacity: null,
            units: null
        },
        // Ping target
        ping_target_data: {
            success_rate_lower_limit: null,
            success_rate_upper_limit: null,
            latency_lower_limit: null,
            latency_upper_limit: null,
            with_jitter: null,
            jitter_lower_limit: null,
            jitter_upper_limit: null
        },

     // Device History
        dh_info: 'name',
        history: null,
        graph_type: "default",
        report_type_alias: {
            'device_history': 'device history',
            'target_history': 'target history'
        },
        gettingHistory: false,
        history_message: "Select a Graph Type.",
        // Health
        health_height: 300,
        health_width: 1400,
        health_data: {
            labels: ['L1','L2','L3','L4','L5'],
            datasets: [
                {
                    label: 'CPU',
                    data: [10,20,20,80,8],
                    borderColor: 'Green',
                    backgroundColor: 'Green',
                },
                {
                    label: 'CPU Tolerance',
                     data: [60,60,60,60,90],
                    borderColor: '#66ff99',
                    backgroundColor:'#66ff99',
                },
                {
                    label: 'Memory',
                    data: [15,28,12,69,96],
                    borderColor: 'Darkblue',
                    backgroundColor: 'Darkblue',
                },
                {
                    label: 'Memory Tolerance',
                     data: [70,70,70,70,50],
                    borderColor: 'Skyblue',
                    backgroundColor:'Skyblue',
                },
                
            ]
        },
        qos_data: {
            labels: ['L1','L2','L3','L4','L5'],
            datasets: [
                {
                    label: 'RTT',
                    data: [10,20,20,80,8],
                    borderColor: 'Green',
                    backgroundColor: 'Green',
                },
                {
                    label: 'Latency',
                     data: [60,60,60,60,90],
                    borderColor: '#66ff99',
                    backgroundColor:'#66ff99',
                },
                {
                    label: 'Jitter',
                    data: [15,28,12,69,96],
                    borderColor: 'Darkblue',
                    backgroundColor: 'Darkblue',
                }
                
            ]
        },
        health_gm: 'health', // Health Graph Mode
        hstart: { date: null, time: '00:00' },
        hend: { date: null, time: null },
        // Report
        downloading: false,
        // Interfaces
        interfaces_height: 300,
        interfaces_width: 1000,
        interfaces_fg: [
            {
                name: "Interface 1",
                data: {
                    labels: ['2023-03-15 12:00:00','L2','L3','L4','L5'],
                    datasets: [
                        {
                            label: 'Input',
                            data: [60,60,60,60,60],
                            borderColor: '#00802b',
                            backgroundColor: '#00802b',
                        },
                        {
                            label: 'Output',
                            data: [10,20,20,80,10],
                            borderColor: '#66ff99',
                            backgroundColor:'#66ff99',
                        },
                        
                    ]
                }
            },
            {
                name: "Interface 2",
                data: {
                    labels: ['2023-03-15 12:00:00','L2','L3','L4','L5'],
                    datasets: [
                        {
                            label: 'Input',
                            data: [2000,3000,3400,6000,18000],
                            borderColor: '#00802b',
                            backgroundColor: '#00802b',
                        },
                        {
                            label: 'Output',
                            data: [2100,3100,3200,6500,12000],
                            borderColor: '#66ff99',
                            backgroundColor:'#66ff99',
                        },
                        
                    ]
                }
            }
        ],
        selected_interface: { name: null, data: { labels: [], datasets: [] } },
        dselected_interface: { name: null, data: { labels: [], datasets: [] } },
        


      targets: [],
      targetsSubheader: "Select a device to get his targets...",
      gettingTargets: false,
      targetsFilter: "all",
      modifyingTargets: false,
      markerTargets: [],
      totalMarkerTargets: 0,
      gettingMarkerTargets: false,
      newTargetAlias: null,
      newTargetTolerance: 70,
      markers_targets: false,
      // Devices for the targets.
      devices: [],
      devices_filter: null,
      only_active: true,
      gettingDevices: false,
      d: {uid: null, name: "Name", ip: "0.0.0.0", role: 'role', os: 'os'}, // dts
      selected_device: "invalid", // dt_selected
      selected_device_disable: false,  // disable_dts
      detail_mode: 'info',
      bases: {
          // Device Roles
          role: require("@/assets/img/bases/roles/default_device_role.png"),
          router: require("@/assets/img/bases/roles/base_router.png"),
          switch: require("@/assets/img/bases/roles/base_switch.png"),
          server: require("@/assets/img/bases/roles/base_server.png"),
          accesspoint: require("@/assets/img/bases/roles/base_ap.png"),
          firewall: require("@/assets/img/bases/roles/base_firewall.png"),
          other: require("@/assets/img/bases/roles/base_other.png"),
          // Device OS's
          os: require("@/assets/img/bases/os/default_device_os.png"),
          ios: require("@/assets/img/bases/os/base_cisco_ios.png"),
          iosxr: require("@/assets/img/bases/os/base_cisco_xr.png"),
          iosxe: require("@/assets/img/bases/os/base_cisco_xe.png"),
          reap: require("@/assets/img/bases/os/base_reap.png"),
          reap2900: require("@/assets/img/bases/os/base_reap_2900.png"),
          rax700: require("@/assets/img/bases/os/base_reap_rax700.png"),
          ros: require("@/assets/img/bases/os/base_ros.png"),
          ros2800: require("@/assets/img/bases/os/base_ros_2800.png"),
          timos: require("@/assets/img/bases/os/base_timos.png"),
          vrp: require("@/assets/img/bases/os/base_vrp.png"),
          huawei: require("@/assets/img/bases/os/base_huawei.png"),
          ubuntu: require("@/assets/img/bases/os/base_ubuntu.png"),
          meraki: require("@/assets/img/bases/os/base_meraki.png"),
          superficial: require("@/assets/img/bases/os/base_superficial.png")
      },
      oss:{
        os:           'os',
        ios:          'ios',
        iosxr:        'iosxr',
        iosxe:        'iosxe',
        huawei:       'vrp',
        alu:          'timos',
        raisecom2900: 'reap2900',
        raisecom2800: 'ros2800',
        rax700:       'rax700',
        ubuntu:       'ubuntu',
        meraki:       'meraki',
        superficial:  'superficial'
      },
      // Notificators
      savingNotificators: false,
      mapKey: null,

      //  Error
      some_error: false,
      cleaningMonitoring: false,
      
      // CLOUD DEVICES
      cloud_mode: 'table',
      all_cloud_markers: {},
      cloud_markers: [],
      getting_cloud_markers: false,
      cloud_dtype: 'accesspoint',
      cloud_device: null, // For detail
      cloud_device_mode: 'info', // For detail

      vendor_sp: {
        latency_average: 'ms',
        performance_score: ''
      },
      // History
      cloud_device_history: null,       // Object to store de request data.
      cloud_history_mode: 'device',     // Device, Radios, Ports, Etc.
      cloud_device_history_message: '', // Message
      cloud_device_graph_type: null,    // Graph Selector inside space: null(the first option in object), rates, latency, etc.
      cloud_device_radio_graph: null,
      getting_cloud_history: false,
      cl_start: { date: null, time: '00:00' },
      cl_end: { date: null, time: null },
      // Events
      cloud_device_events: null,
      getting_cloud_events: false,
      cloud_device_event_type: null,
      // Report
      getting_cd_report: false,


      search_cloud_type: 'name',
      search_cloud_word: '',
      cloud_devices_sorter: null,
      refresh_cloud_sorter: 1,

      // Laboratory | Tester
      tester: false,
      tester_mode: 'ping',
      // Ping
      pinging: false,
      tester_ping: {
        device: null,
        results: {}
      },
      deftp: {
        device: null,
        results:{}
      },
      // Logs
      getting_logs: false,
      tester_logs: {
        device: null,
        date: null,
        hour: null,
        logs: {}
      },
      tester_logs_def : {
        device: null,
        date: null,
        hour: null,
        logs: {}
      }


    }
  },
  methods:{
    // General
    capitalize(_string){
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    // =============================================== Monitoring
    startChecking(){
      // Verify the listener.
      this.pollingListener = String(localStorage.getItem('alchemyPollingListener'))

      //console.log(this.pollingListener, typeof(this.pollingListener))
      
      if (this.pollingListener == 'null'){
        //console.log('No existente, creando...')
        this.pollingListener = setInterval(this.getMonitoringStatus, 1000)
        localStorage.setItem('alchemyPollingListener', this.pollingListener)
      }
      else{
        clearInterval(parseInt(this.pollingListener))
        this.pollingListener = setInterval(this.getMonitoringStatus, 1000)
        localStorage.setItem('alchemyPollingListener', this.pollingListener)
      }
    },
    toggleAutoRefresh(){
        if (this.autoRefresh){
            try {
                clearInterval(this.arid)
                //alert('Stopped: ' + String(this.arid))
            } catch (error) {
                alert(error)
            }
        }
        else{
            this.arid = setInterval(this.getMonitoringStatus, 1000)
            //alert('Started: ' + String(this.arid))
        }
        this.autoRefresh = !this.autoRefresh
    },
    clearMonitoring(){
        this.cleaningMonitoring = true
        this.getMonitoringStatus()
        this.getMarkers()
        this.getMapKey()
        this.cleaningMonitoring = false
    },
    getMonitoringStatus(){
        this.some_error = false
        const params = {listener: this.arid}
        const dest = this.site + '/alchemy/main/getMonitoringStatus'
        axios
            .get(dest, {params})
            .then(rx => {
                this.statusText = rx.data.data.text
                this.statusTimestamp = rx.data.data.timestamp
                this.now = rx.data.data.ts
                if (rx.data.data.update == true){
                    this.getMarkers()
                    this.getCloudMarkers()
                }
            })
            .catch(error => {
                this.statusText = this.processErrorMessage(error,'console')
                this.some_error = true
            });
    },
    getMarkers(sm=false){
        this.reRenderMap()
        this.gettingMarkers = true
        this.markers = []
        this.markerView = false
        this.clearMarkerView()
        this.some_error = false
        const params = {filter: this.markersFilter}
        const dest = this.site + '/alchemy/monitoring/getMarkers'
        axios
            .get(dest, {params})
            .then(rx => {
                this.markers = rx.data.data.markers
                this.gettingMarkers = false
                if (this.sectionView == 'map'){
                    this.setMapCenter(this.centerLatitute, this.centerLongitude, 4)
                }
                //this.getMonitoringStatus()
                this.reRenderMap()
                if (sm==true){
                    this.selected_marker = this.cloneObject(this.markers[this.smidx])
                }
            })
            .catch(error => {
                this.statusText = this.processErrorMessage(error)
                this.some_error = true
                this.gettingMarkers = false
            });
    },
    refreshMarkersFilter(){
        this.refreshMarkers++;
    },
    viewMarker(_marker, prefered_detail_mode='info'){
        this.selected_marker = this.cloneObject(_marker)
        this.smcopy = this.cloneObject(_marker)
        this.smidx = this.markers.indexOf(_marker)
        // Clean
        this.markerTargets = []
        this.resetObject(this.selected_target, null)
        this.selected_target = this.selected_target_default
        // Get the available targets.
        if (this.selected_marker.os != 'superficial'){
            //this.getAvailableTargets(this.selected_marker)

            // Get the current targets.
            this.getTargets(this.selected_marker)
        }
        // Clear detail mode.
        this.detail_mode = prefered_detail_mode
        this.health_gm = 'health'
        // Get the history.
        this.setNow()
        this.viewHistory(_marker)
        // Clean targets
        this.newTargetAlias = null
        this.resetObject(this.interface_target_data, null)
        this.resetObject(this.ping_target_data, null)
    },
    clearMarkerView(){
        this.selected_marker = {
            polling: { classIndicator: "btn-dark" },
            connectivity: { value: null, classIndicator: "btn-dark" },
            ping: { success: 0, loss: 0 , classIndicator: "btn-dark" },
            cpu: { value: 0, classIndicator: "btn-dark" },
            memory: { value: 0, classIndicator: "btn-dark" },
            targets: {total: {count:0, data: []}}
        }
        // Targets
        this.target_mode = 'interfaces_services'
        try {
            this.resetObject(this.selected_target, null)
            this.resetObject(this.interface_target_data, null)
            this.resetObject(this.ping_target_data, null)
        } catch (error) {
            console.log('Clear Marker View:', error)
        }
    },
    clearTargets(){
        this.newTargetAlias = null
        var cm = this.selected_target.type
        this.resetObject(this.selected_target, null)
        this.resetObject(this.interface_target_data, null)
        this.resetObject(this.ping_target_data, null)
        this.selected_target.type = cm
        this.selected_target_chart = null
        this.target_chart_ready = false
    },
    setMapCenter(latitude, longitude, zoom=4.75){
        this.markerView = false
        this.zoom = zoom
        this.centerLatitute = latitude
        this.centerLongitude = longitude
        this.sectionView = 'map'
    },
    reRenderMap(){
        this.markerMapKey += 1
    },
    toggleView(){
        if (this.sectionView == 'map'){
            this.sectionView = 'list'
        }
        else if (this.sectionView == 'list'){
            this.reRenderMap()
            this.sectionView = 'map'
        }
    },
    // =============================================== History
    viewHistory(device){
        this.selected_marker = this.cloneObject(device)
        this.setNow()
        this.getHistoryGraphs(false)
    },
    clearHistory(){
        this.selected_marker = {
            polling: { classIndicator: "btn-dark" },
            connectivity: { value: null, classIndicator: "btn-dark" },
            ping: { success: 0, loss: 0 , classIndicator: "btn-dark" },
            cpu: { value: 0, classIndicator: "btn-dark" },
            memory: { value: 0, classIndicator: "btn-dark" },
            targets: {total: {count:0, data: []}}
        }
        this.graph_type = "default"
        this.selected_interface = this.dselected_interface
    },
    getHistoryGraphs(notify_user=false){
        this.gettingHistory = true
        this.selected_interface = this.dselected_interface
        this.history_message = "Getting history..."
        const params = { parent_device: this.selected_marker.uid,
                         target_name: 'local',
                         start: `${this.hstart.date} ${this.hstart.time}:00`,
                         end: `${this.hend.date} ${this.hend.time}:00` }
        const dest = this.site + '/alchemy/monitoring/getHistoryGraphs'
        axios
            .get(dest, {params})
            .then(rx => {
                this.history = rx.data.data.graphs
                this.health_data = this.history.health
                this.qos_data = this.history.qos
                this.interfaces_fg = this.history.interfaces
                this.history_message = "The data is ready, select a graph type."
                this.gettingHistory = false
            })
            .catch(error => {
                if (notify_user){
                    this.history_message = this.processErrorMessage(error)
                }
                this.history = null
                this.health_data = null
                this.qos_data = null
                this.gettingHistory = false
            });
    },
    getTargetHistoryGraphs(notify_user=false){
        this.gettingTargetHistory = true
        this.target_chart_ready = false
        const params = { 
            parent_device: this.selected_marker.uid,
            target_name: this.selected_target_chart.name,
            type: this.selected_target_chart.type,
            start: `${this.tstart.date} ${this.tstart.time}:00`,
            end: `${this.tend.date} ${this.tend.time}:00` 
        }
        const dest = this.site + '/alchemy/monitoring/getTargetHistoryGraphs'
        axios
            .get(dest, {params})
            .then(rx => {
                var data = rx.data.data
                this.target_history = data.graphs
                this.gettingTargetHistory = false
                this.target_chart_ready = true
            })
            .catch(error => {
                if (!notify_user){
                    this.processErrorMessage(error)
                }
                this.gettingTargetHistory = false
                this.target_chart_ready = false
            });
    },
    getHistoryReport(_rtype, _target=null){
        this.setUnique()
        if (_rtype == 'device_history'){
            if ( !confirm(`Generate ${this.report_type_alias[_rtype]} report of ${this.selected_marker.name}?`) ){
                return
            }
        }
        else if (_rtype == 'target_history'){
            if ( !confirm(`Generate ${this.report_type_alias[_rtype]} report of ${_target}?`) ){
                return
            }
        }
        
        // Get the report.
        this.downloading = true
        const dest = this.site + '/alchemy/monitoring/getHistoryReport' + `?unique=${this.unique}`
        const params = {
            unique: this.unique,
            reptype: _rtype,
            parent_device: this.selected_marker.uid,
            parent_name: this.selected_marker.name,
            target_name: _target
        }
        if (_rtype == 'device_history'){
            params.start = `${this.hstart.date} ${this.hstart.time}`
            params.end = `${this.hend.date} ${this.hend.time}`
            params.type = 'device'
            params.target_name = 'local'
        }
        else if (_rtype == 'target_history'){
            params.start = `${this.tstart.date} ${this.tstart.time}`
            params.end = `${this.tend.date} ${this.tend.time}`
            params.type = this.selected_target_chart.type
        }
        // Generate download.
        axios.get(dest, { params: params, responseType: 'blob' } )
            .then((rx) => {
                const url = URL.createObjectURL(rx.data);
                const a = document.createElement('a');
                a.style = 'display: none';
                a.href = url;
                a.download = rx.statusText;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
                this.downloading = false
            })
            .catch((error) => {
                alert(error.response.statusText)
                this.downloading = false
            });
    },
    toggleHealthGraph(){
        if (this.health_gm == 'health'){
            this.health_gm = 'qos'
        }
        else if(this.health_gm == 'qos'){
            this.health_gm = 'health'
        }
    },
    toggleTargetView(){
        if (this.target_view == 'list'){
            this.target_view = 'chart'
        }
        else if(this.target_view == 'chart'){
            this.target_view = 'list'
        }
    },
    subtractHours(date, hours) {
        date.setHours(date.getHours() - hours);
        return date;
    },
    setNow(){
        this.now = new Date();
        //var now_to_min = this.now
        //const newDate = this.subtractHours(now_to_min, 2);

        // Day
        if (this.now.getDate() < 10){
            var day = '0' + String(this.now.getDate())
        }
        else{
            var day = this.now.getDate()
        }
        // Month
        if (this.now.getMonth()+1 < 10){
            var month = '0' + String(this.now.getMonth()+1)
        }
        else{
            var month = this.now.getMonth()+1
        }


        this.today = `${this.now.getFullYear()}-${month}-${day}`

        if (this.now.getHours() < 10){
            var h = '0' + String(this.now.getHours())
        }
        else{
            var h = this.now.getHours()
        }

        if (this.now.getMinutes() < 10){
            var m = '0' + String(this.now.getMinutes())
        }
        else{
            var m = this.now.getMinutes()
        }
        this.time = `${h}:${m}`
        // Device
        this.hstart.date = this.today
        this.hend.date = this.today
        this.hend.time = this.time
        // Target
        this.tstart.date = this.today
        this.tend.date = this.today
        this.tend.time = this.time
        // Cloud
        this.cl_start.date = this.today
        this.cl_end.date = this.today
        this.cl_end.time = this.time
    },
    setUnique(){
        var date = new Date();
        this.unique = date.getTime()
    },
    // =============================================== Targets
    getAvailableTargets(_marker){
        this.some_error = false
        this.selected_target = this.selected_target_default
        this.gettingAvTargets = true
        // Sending request
        const params = {}
        const dest = this.site + '/alchemy/monitoring/getAvailableTargets'
        axios
            .post(dest, _marker)
            .then(rx => {
                this.availableTargets = rx.data.data.availableTargets
                this.gettingAvTargets = false
            })
            .catch(error => {
                this.statusText = this.processErrorMessage(error)
                this.some_error = true
                this.gettingAvTargets = false
            });
    },
    addTarget(){
        // Sending request
        this.addingTarget = true
        this.selected_target.alias = this.newTargetAlias
        this.selected_target.parent_device = this.selected_marker.uid
        // Define special data
        if (this.selected_target.type == 'interface'){
            this.selected_target.special = this.interface_target_data
        }
        else if (this.selected_target.type == 'os-service'){
            this.selected_target.special = {}
        }
        else if (this.selected_target.type == 'ping'){
            this.selected_target.special = this.ping_target_data
        }
        const dest = this.site + '/alchemy/monitoring/addTarget'
        axios
            .post(dest, this.selected_target)
            .then(rx => {
                alert(rx.data.data.status)
                this.addingTarget = false
                // Remove the target added from available targets
                var itr = this.availableTargets.indexOf(this.selected_target)
                this.availableTargets.splice(itr,1)
                // Clean
                //this.selected_target = this.selected_target_default
                // Get the registered targets.
                this.getTargets(this.selected_marker)
                // Clean
                this.clearTargets()
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.addingTarget = false
            });
    },
    deleteTarget(_target){
        if ( !confirm('Delete target ' + _target['name'] + '?') ){
            return
        }
        this.deletingTarget = true
        const dest = this.site + '/alchemy/monitoring/deleteTarget'
        axios
            .post(dest, _target)
            .then(rx => {
                this.getTargets(this.selected_marker)
                alert(rx.data.data.status)
                this.deletingTarget = false
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.deletingTarget = false
            });
    },
    getTargets(_marker){
        if (_marker.name == null){
            alert('Select a valid device.')
            return 
        }
        this.target_data_mode = 'alias'
        this.target_data = {
            capacity: null,
            cunits: 'mb'
        }
        this.gettingMarkerTargets = true
        this.markerTargets = []
        this.totalMarkerTargets = 0
        const params = {uid: _marker.uid, filter: "all"}
        const dest = this.site + '/alchemy/monitoring/getTargets'
        axios
            .get(dest, {params})
            .then(rx => {
                this.markerTargets = rx.data.data.targets
                this.totalMarkerTargets = this.markerTargets.length
                this.gettingMarkerTargets = false
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.gettingMarkerTargets = false
            });
    },
    getImage(base){
        var imgbase = String(base).toLowerCase()
        return this.bases[imgbase]
    },
    // Notificators
    saveNotificators(){
        if(this.dvmode == 'standard_devices'){
            if ( !confirm(`Save changes of ${this.selected_marker.name}?`) ){
                return
            }
            var params = {
                notificators: this.selected_marker.notificators,
                uid: this.selected_marker.uid,
                type: this.dvmode
            }
            var dest = this.site + '/alchemy/monitoring/saveNotificators'
        }
        else if (this.dvmode == 'cloud_devices'){
            if ( !confirm(`Save changes of ${this.cloud_device.name}?`) ){
                return
            }
            var params = {
                notificators: this.cloud_device.notificators,
                uid: this.cloud_device.uid,
                type: this.cloud_dtype
            }
            var dest = this.site + '/alchemy/monitoring/saveCloudNotificators'
        }
        this.savingNotificators = true
        axios
            .post(dest, params)
            .then(rx => {
                if (this.dvmode == 'standard_devices'){
                    this.getMarkers(true)
                }
                alert(rx.data.data.status)
                this.savingNotificators = false
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.savingNotificators = false
                this.selected_marker.notificators = this.cloneObject(this.smcopy.notificators)
            });
    },

    // CLOUD DEVICES
    setCloudMarkers(){
        this.cloud_markers = this.all_cloud_markers[this.cloud_dtype]
    },
    getCloudMarkers(){
        this.getting_cloud_markers = true
        const params = {}
        const dest = this.site + '/alchemy/monitoring/getCloudMarkers'
        axios
            .get(dest, {params})
            .then(rx => {
                this.all_cloud_markers = rx.data.data.markers
                this.cloud_markers = this.all_cloud_markers[this.cloud_dtype]
                this.getting_cloud_markers = false
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.getting_cloud_markers = false
            });
    },
    setCloudDevice(direction){
        var cidx = this.filtered_cloud_markers.indexOf(this.cloud_device)
        var cidx_past = cidx - 1
        var cidx_next = cidx + 1
            try {
                if (direction == 'past' && cidx_past > -1){
                    this.cloud_device = this.filtered_cloud_markers[cidx_past]
                }
                else if (direction == 'next' && cidx_next < this.filtered_cloud_markers.length){
                    this.cloud_device = this.filtered_cloud_markers[cidx_next]
                }
            } catch (error) {
                this.cloud_device = this.filtered_cloud_markers[cidx]
            }
        // Clear graphs
        this.cloud_device_history = null
        this.cloud_device_graph_type = null
        this.cloud_history_mode = 'device'
    },
    clearCloudMonitoring(){
        this.getCloudMarkers()
    },
    refreshCloudSorter(){
        this.refresh_cloud_sorter++;
    },
    // History
    getCloudDeviceHistory(notify_user=false){
        this.getting_cloud_history = true
        this.cloud_device_history = null
        this.cloud_device_radio_graph = null
        // Parameters
        const params = { uid: this.cloud_device.uid,
                         dtype: this.cloud_device.role,
                         start: `${this.cl_start.date} ${this.cl_start.time}:00`,
                         end: `${this.cl_end.date} ${this.cl_end.time}:00` }
        const dest = this.site + '/alchemy/monitoring/getCloudDeviceHistory'
        axios
            .get(dest, {params})
            .then(rx => {
                this.cloud_device_history = rx.data.data.history
                console.log(this.cloud_device_history)
                this.getting_cloud_history = false
            })
            .catch(error => {
                if (notify_user){
                    this.history_message = this.processErrorMessage(error)
                }
                this.getting_cloud_history = false
            });
    },
    getCloudDeviceReport(){
        this.setUnique()
        if ( !confirm(`Generate history report?`) ){
            return
        }
        this.getting_cd_report = true
        var params = {
            uid: this.cloud_device.uid,
            cloud_dtype: this.cloud_dtype,
            mode: this.cloud_history_mode,
            name: this.cloud_device.name,
            start: `${this.cl_start.date} ${this.cl_start.time}:00`,
            end: `${this.cl_end.date} ${this.cl_end.time}:00`,
            unique: this.unique
        }
        if (this.cloud_history_mode == 'device'){
            //
        }
        else if (this.cloud_history_mode == 'radios'){
            params.radio_mac = this.cloud_device_radio_graph.mac
            params.band = this.cloud_device_radio_graph.band_ghz
        }
        const dest = this.site + '/alchemy/monitoring/getCloudDeviceReport'
        // Generate download.
        axios.get(dest, { params: params, responseType: 'blob' } )
            .then((rx) => {
                const url = URL.createObjectURL(rx.data);
                const a = document.createElement('a');
                a.style = 'display: none';
                a.href = url;
                a.download = rx.statusText;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
                this.getting_cd_report = false
            })
            .catch((error) => {
                alert(error.response.statusText)
                this.getting_cd_report = false
            });
    },
    // Events
    getCloudDeviceEvents(notify_user=false){
        this.getting_cloud_events = true
        this.cloud_device_events= null
        // Parameters
        const params = { uid: this.cloud_device.uid,
                         name: this.cloud_device.name,
                         dtype: this.cloud_device.role,
                         start: `${this.cl_start.date} ${this.cl_start.time}:00`,
                         end: `${this.cl_end.date} ${this.cl_end.time}:00` }
        const dest = this.site + '/alchemy/monitoring/getCloudDeviceEvents'
        axios
            .get(dest, {params})
            .then(rx => {
                this.cloud_device_events = rx.data.data.events
                this.getting_cloud_events = false
            })
            .catch(error => {
                if (notify_user){
                    this.processErrorMessage(error)
                }
                this.getting_cloud_events = false
            });
    },

    // Laboratory | Tester
    cleanLAB(){
        this.tester_ping = this.cloneObject( this.deftp )
        this.search_std_type = 'name'
        this.searchWord = null
        this.cats = null
        this.only_active = true
    },
    // Laboratory | Ping
    ping(){
        var doi = this.tester_ping.device
        var kta = doi.ip // Key To Add
        if (!Object.keys(this.tester_ping.results).includes(kta)){
            this.tester_ping.results[kta] = {
                serkey: doi.service_key,
                name: doi.name,
                alias: doi.alias,
                ip: doi.ip,
                data: [],
                pinging: true
            }
        }
        else{
            if (this.tester_ping.results[kta].pinging){
                alert('Active ping to device, wait a minute.')
                return
            }
            this.tester_ping.results[kta].pinging = true
        }
        this.pinging = true
        const params = {
            ip: kta,
            repeats: 5
        }
        const dest = this.site + '/alchemy/monitoring/ping'
        axios
            .post(dest, params)
            .then(rx => {
                this.tester_ping.results[rx.data.data.ping.ip].data.push(rx.data.data.ping)
                this.tester_ping.results[rx.data.data.ping.ip].pinging = false
                this.pinging = false
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.pinging = false
                this.tester_ping.results[kta].pinging = false
            });
    },
    // Laboratory | Logs
    logs(_type){
        if (!this.tester_logs.device){
            return
        }
        this.tester_logs.date = null
        this.tester_logs.hour = null
        this.getting_logs = true
        const params = { uid: this.tester_logs.device.uid, type: _type }
        const dest = this.site + '/alchemy/monitoring/logs'
        axios
            .get(dest, {params})
            .then(rx => {
                console.log(rx.data.data)
                this.tester_logs.logs = rx.data.data.logs
                this.getting_logs = false
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.getting_logs = false
            });
    },

    // Laboratory | Terminal
    // Laboratory | Reporter



    // For the map
    getMapKey(){
        const params = {}
        const dest = this.site + '/alchemy/monitoring/getMapMonitoringKey'
        axios
            .get(dest, {params})
            .then(rx => {
                this.mapKey = rx.data.key
            })
            .catch(error => {
                this.processErrorMessage(error)
            });
    },
    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    // Misc
    resetObject(ob, val){
      Object.keys(ob).forEach(k => ob[k] = val);
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  computed: {
    filteredTargets(){
        var ft = []
        for (let i = 0; i < this.targets.length; i++) {
            const target = this.targets[i];
            target.originalIndex = i
            if (this.targetsFilter == 'all'){ft.push(target)}
            else if (target.type == this.targetsFilter){ft.push(target)}
        }
        return ft
    },
    filteredMarkers(){
        this.refreshMarkers
        if (!this.searchWord){
            var temp_markers = this.markers
        }
        else{
            this.searchWord = this.searchWord.toUpperCase()
            var temp_markers = this.markers.filter( marker => marker[this.search_std_type].toUpperCase().includes(this.searchWord) );
        }
       
        // Filter
        if (this.devices_filter == null){
            temp_markers.sort()
        }
        else if (this.devices_filter == 'cpu_desc'){
            temp_markers = temp_markers.sort((a, b) => b.cpu.value-a.cpu.value);
        }
        else if (this.devices_filter == 'memory_desc'){
            temp_markers = temp_markers.sort((a, b) => b.memory.value-a.memory.value);
        }
        else if (this.devices_filter == 'ping_lat_desc'){
            temp_markers = temp_markers.sort((a, b) => b.ping.latency-a.ping.latency);
        }
        else if (this.devices_filter == 'alerts'){
            temp_markers = temp_markers.sort((a, b) => b.alerts.length - a.alerts.length );
        }

        // Active
        if (this.only_active){
            temp_markers = temp_markers.filter(marker =>  marker.active)
        }
        
        // By OS
        if(this.cats == true){
            temp_markers = temp_markers.filter(marker =>  marker.os == 'superficial')
        }
        else if (this.cats == false){
            temp_markers = temp_markers.filter(marker =>  marker.os != 'superficial')
        }
        return temp_markers

    },
    filteredMarkerTargets(){
        if (this.searchWordTarget == ''){
            return this.markerTargets
        }
        this.searchWordTarget = this.searchWordTarget.toLowerCase()
        return this.markerTargets.filter(target => target[this.target_show_type].toLowerCase().includes(this.searchWordTarget));
    },
    // CLOUD DEVICES
    filtered_cloud_markers(){
        this.refresh_cloud_sorter
        if (this.search_cloud_word == ''){
            var temp_markers = this.cloud_markers
        }
        else{
            this.search_cloud_word = this.search_cloud_word.toLowerCase()
            var temp_markers = this.cloud_markers.filter( marker => marker[this.search_cloud_type].toLowerCase().includes(this.search_cloud_word) );
        }

        // Filter
        if (this.cloud_devices_sorter == null){
            temp_markers.sort()
        }
        else if (this.cloud_devices_sorter== 'ce_desc'){
            temp_markers = temp_markers.sort((a, b) => b.connected_endpoints - a.connected_endpoints);
        }
        else if (this.cloud_devices_sorter == 'rxkbps_desc'){
            temp_markers = temp_markers.sort((a, b) => b.rx_kbps - a.rx_kbps);
        }
        else if (this.cloud_devices_sorter == 'txkbps_desc'){
            temp_markers = temp_markers.sort((a, b) => b.tx_kbps - a.tx_kbps);
        }
        else if (this.cloud_devices_sorter == 'alerts_desc'){
            temp_markers = temp_markers.sort((a, b) => b.alerts.length - a.alerts.length);
        }
        

        // Active
        if (this.only_active){
            temp_markers = temp_markers.filter(marker =>  marker.active)
        }

        return temp_markers
    }

  },
  created: function(){
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
  },
  mounted: function(){
    this.getMapKey()
    this.getMarkers()
    //this.getMonitoringStatus()
    //this.toggleAutoRefresh()
    // Cloud
    this.getCloudMarkers()
    this.setNow()
  }
}
</script>

<style scoped>


  .btn-alchemy{
    background-color: rgb(115, 70, 205);
    color: White;
    transition-duration: 0.6s;
  }
  .btn-alchemy:hover{
    background-color: rgb(48, 48, 105);
    color: rgb(115, 70, 205);
  }

  .btn-alchemy-dark{
    background-color: rgb(0,0,26);
    color: White;
    transition-duration: 0.6s;
  }
  .btn-alchemy-dark:hover{
    background-color: rgb(115, 70, 205);
    color: rgb(0,0,26);
  }

  .btn-alchemy-success{
    background-color: rgb(115, 70, 205);
    color: White;
  }
  .btn-alchemy-danger{
    background-color: rgb(161, 91, 0);
    color: White;
  }
  .btn-alchemy-warning{
    background-color: rgb(187, 255, 0);
    color: rgb(0, 0, 0);
  }
  .btn-alchemy-off{
    background-color: rgb(0, 3, 25);
    color: rgb(161, 91, 0);
  }

  .bg-alchemy{
    background-color: rgb(0, 0, 26);
    color: White;
    transition-duration: 0.7s;
  }
  .bg-alchemy:hover{
    background-color: rgb(0, 0, 98);
    color: White;
  }
  .bg-alchemy-two{
    background-color: rgb(0, 0, 26);
    color: White;
    transition-duration: 0.7s;
  }

  .bg-alchemy-success{
    background-color: rgb(115, 70, 205);
    color: White;
  }
  .bg-alchemy-danger{
    background-color: rgb(161, 91, 0);
    color: White;
    transition-duration: 0.7s;
  }
  .bg-alchemy-danger:hover{
    background-color: rgb(70, 40, 0);
  }
  .bg-alchemy-dark{
    background-color: rgb(0,0,26);
    color: White;
  }

  .thehover{
    opacity: 0.6;
  }
  .thehover:hover{
    opacity: 2;
  }

  .border-alchemy{
    border: solid 1px rgb(115, 70, 205);
  }
  .border-top-alchemy{
    border-top: solid 0.5px rgb(115, 70, 205);
  }
  .border-bottom-alchemy{
    border-bottom: solid 0.5px rgb(115, 70, 205);
  }
  .border-start-alchemy{
    border-left: solid 0.5px rgb(115, 70, 205);
  }
  .border-end-alchemy{
    border-right: solid 0.5px rgb(115, 70, 205);
  }

  .text-alchemy{
    color: rgb(115, 70, 205);
  }

  .element-hover{
    opacity: 0.6;
    transition-duration: 0.5s;
    border-bottom: solid 1px black;
  }
  .element-hover:hover{
    opacity: 1.0;
    border-bottom: solid 1px rgb(115, 70, 205);
  }

  .disabled-div{
    pointer-events: none;
    opacity: 0.5;
  }

  .section-button{
    background-color: Black;
    border: solid 2px Black;
    color: White;
  }
  .section-button:hover{
    color: rgb(72,167,238);
    border-bottom: solid 2px rgb(162, 200, 250);
  }


  /* Table with static header */
    .tableFixHead {
        overflow-y: auto;
      }
    .tableFixHead thead th {
        position: sticky;
        top: 0;
        text-align: center;
        z-index: 1;
    }
    table {
        border-collapse: collapse;
        width: 100%;
    }
    th, td {
        padding: 8px 16px;
    }
    th {
        background: #eee;
    }

    /* VUE Transition*/
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.1s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 1;
    }




    .slide-fade-enter-active {
        transition: all 2s ease-out;
    }

    .slide-fade-leave-active {
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter-from,
    .slide-fade-leave-to {
        transform: translateX(20px);
        opacity: 0;
    }


    .vertical-row {
        Float: center;
        height: 25px;
        width: 2px; /* edit this if you want */
        background-color: white;
    } 
</style>
